<template>
  <div class="chatArea" v-loading="loading">
    <div class="m-operation">
      <div>实时转录</div>
      <div>{{ createTime }}</div>
    </div>
    <div class="titBar">
      <div class="titBarLeft">
        <div
          @click="cutBar(index)"
          :class="pageStatus == index ? 'titBarBorder' : ''"
          v-for="(i, index) in titBarList"
          :key="index + 'a'"
        >
          <img :src="pageStatus == index ? i.ico : i.ico1" alt="" />{{
            i.title
          }}
        </div>
      </div>
      <div class="titBarRig">
        <!-- <img src="@/assets/icon/classroomObservation/put.png" alt="" />
				<div style="cursor: pointer">收起</div> -->
      </div>
    </div>
    <div class="ca-top">
      <!-- 开始页面 -->
      <startPage
        v-show="showIndexPage"
        @startTape="onClickStartRecord"
        @uploadTape="uploadRecording"
        :uploadFileLoading="uploadFileLoading"
        :teacherVoiceprintList="teacherVoiceprintList"
        :chosenVoiceprint="chosenVoiceprint"
        :controlsStatus="controlsStatus"
        ref="startPageRef"
      />
      <!-- 原文速递 -->
      <transcription
        v-show="pageStatus == 1 && !showIndexPage"
        :showGetTextLoading="showGetTextLoading"
        :data="transcriptionData"
      >
        <!-- <el-button
					style="position: absolute; bottom: 10px; right: 20px"
					type="primary"
					@click.stop="saveEditorBar(true)"
					>保存</el-button
				> -->
      </transcription>
      <!-- ai对话 -->
      <tape
        ref="tapeRef"
        :aiNameList="roleList"
        :chatData="chatList"
        v-show="pageStatus == 0 && !showIndexPage"
        :loading="chatLoading"
      />
      <!-- <div class="t-t-m-Item" v-show="cardStatus==1"> -->
      <EditorBar
        class="editorBar"
        :showGetTextLoading="showGetTextLoading"
        :value="editorBarData.content"
        @change="onEdit"
        v-if="pageStatus == 2 && !showIndexPage && editorBarData.type == '0'"
        v-loading="uploadFileLoading"
      >
			  <div class="wavGetTextProgress" v-if="wavGetTextLoading" style="position: absolute; bottom: 20px; right: 285px; z-index: 10002">
					<el-progress :text-inside="true" :stroke-width="26" :percentage="wavGetTextProgress"></el-progress>
				</div>
        <el-button
          style="position: absolute; bottom: 20px; right: 185px; z-index: 10002"
          size="small"
          v-if="wavGetTextLoading"
          type="danger"
          @click.stop="stopWavGetText()"
          >终止转译</el-button
        >
        <el-popover placement="top" trigger="hover">
          <el-button size="small" @click.stop="startContinuousJobs('role')">
            说话人编码
          </el-button>
          <el-button
            size="small"
            @click.stop="startContinuousJobs('actionType')"
          >
            行为编码
          </el-button>
          <el-button
            slot="reference"
            style="position: absolute; bottom: 20px; right: 90px; z-index: 10002"
            size="small"
            type="primary"
            >自动编码</el-button
          >
        </el-popover>
        <el-button
          style="position: absolute; bottom: 20px; right: 20px; z-index: 10002"
          size="small"
          type="primary"
          @click.stop="saveEditorBar(true)"
          >保存</el-button
        >
      </EditorBar>
      <iframe
        ref="viframe"
        v-if="
          pageStatus == 2 &&
            !showIndexPage &&
            editorBarData.type == '1' &&
            /\.(xlsx|doc|docx)$/i.test(editorBarData.url)
        "
        style="width: 100%; height: 100%; border: none"
        v-loading="uploadFileLoading"
        :src="
          'https://view.officeapps.live.com/op/view.aspx?src=' +
            encodeURIComponent(editorBarData.url)
        "
      ></iframe>
      <vpdf
        style="width: 100%; height: 100%; border: none"
        :pdfUrl="editorBarData.url"
        v-if="
          pageStatus == 2 &&
            !showIndexPage &&
            editorBarData.type == '1' &&
            /\.(pdf)$/i.test(editorBarData.url)
        "
      />
      <!-- </div> -->
    </div>
    <div class="ca-bottom">
      <div class="ca-b-operation">
        <div class="ca-b-o-header">
          <div class="ca-b-o-h-left">
            <!-- <div class="ca-b-o-h-l-select" @click.stop="changeAnalysis()">
							<span class="ca-b-o-h-l-s-icon el-icon-collection"></span>
							<div class="ca-b-o-h-s-l-text">课堂观察</div>
							<span class="ca-b-o-h-s-l-icon2 el-icon-caret-top"></span>
						</div> -->

            <div style="margin-right: 16px">
              选择解析器:
              <el-select
                v-model="recorderProvider"
                size="small"
                style="width: 120px"
                :disabled="controlsStatus === 1"
              >
                <el-option key="shengyang" label="声扬" value="shengyang">
                </el-option>
                <el-option key="microsoft" label="微软" value="microsoft">
                </el-option>
              </el-select>
            </div>

            <template v-if="recorderProvider === 'microsoft'">
              <div class="ca-b-o-h-l-select" style="color: #3681fc">
                <div
                  style="cursor: pointer"
                  class="ca-b-o-h-s-l-text"
                  @click.stop="languageShow = !languageShow"
                >
                  {{ languageList.find(i => i.label == languageRadio).lang }}
                </div>

                <div
                  class="languageList"
                  v-click-outside="handleBlur"
                  v-if="languageShow"
                >
                  <el-radio
                    v-for="(i, index) in languageList"
                    :key="index + 'lag'"
                    :class="i.label == languageRadio ? 'radioBg' : ''"
                    v-model.number="languageRadio"
                    @input="languageShow = false"
                    :label.Num="i.label"
                    >{{ i.lang }}</el-radio
                  >
                </div>
              </div>
            </template>
            <template v-if="recorderProvider === 'shengyang'">
              <div class="ca-b-o-h-l-btn">
                <div
                  class="ca-b-o-h-b-l-text"
                  @click.stop="
                    showTeacherVoiceprintBox = !showTeacherVoiceprintBox
                  "
                >
                  教师声纹
                </div>
                <div
                  class="ca_teacherVoiceprintBox"
                  style="cursor: default;"
                  v-click-outside="
                    () => (showTeacherVoiceprintBox = !showTeacherVoiceprintBox)
                  "
                  v-if="showTeacherVoiceprintBox"
                >
                  <p>选择本次使用的教师声纹</p>
                  <el-select
                    v-model="chosenVoiceprint"
                    multiple
                    placeholder="请选择"
                    :multiple-limit="10"
                    filterable
                    clearable
                    :disabled="controlsStatus === 1"
                    style="width: 200px; padding: 0; margin-bottom: 8px;"
                  >
                    <el-option
                      v-for="item in teacherVoiceprintList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <div
                    class="ca_tvb_itemHead"
                    @click.stop="onClickAddNewVoiceprint()"
                    style="width: 200px; box-sizing: border-box"
                  >
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.33337 2H6.66671V10H5.33337V2Z"
                        fill="#3681FC"
                      />
                      <path
                        d="M10 5.33301V6.66634H2V5.33301H10Z"
                        fill="#3681FC"
                      />
                    </svg>
                    添加声纹
                  </div>
                </div>
              </div>
            </template>
            <div
              class="ca-b-o-h-l-btn"
              @click.stop="uploadRecording()"
              v-loading="uploadFileLoading"
            >
              <div class="ca-b-o-h-b-l-text">上传文件</div>
            </div>
          </div>
          <div class="ca-b-o-h-right">
            <div class="ca-b-o-h-r-radio">
              <div
                :class="
                  (index == 0 &&
                    (showIndexPage || [0, 1, 2].includes(controlsStatus))) ||
                  (index == 1 &&
                    !showIndexPage &&
                    ![0, 1, 2].includes(controlsStatus))
                    ? 'TapeCss'
                    : ''
                "
                class="tapeSty"
                @click="cutTape(index)"
                v-for="(i, index) in tapeList"
                :key="index + 'b'"
              >
                <img
                  :src="
                    (index == 0 &&
                      (showIndexPage || [0, 1, 2].includes(controlsStatus))) ||
                    (index == 1 &&
                      !showIndexPage &&
                      ![0, 1, 2].includes(controlsStatus))
                      ? i.ico
                      : i.ico1
                  "
                  alt=""
                />
              </div>

              <!-- <span @click.stop="changeContinuousDialogue(!continuousDialogue)"
								>连续对话</span
							>
							<el-switch
								v-model="continuousDialogue"
								active-color="#3681FC"
								inactive-color="#b2bfc3"
							>
							</el-switch> -->
            </div>
          </div>
        </div>
        <div class="ca-b-o-main">
          <div
            class="ca-b-o-m-tape"
            v-show="controlsStatus == 0"
            @click.stop="onClickStartRecord()"
            v-loading="uploadFileLoading"
          >
            <span class="el-icon-microphone"></span>
            <div class="ca-b-o-m-t-text">点击开始录音</div>
          </div>
          <div
            class="ca-b-o-m-tapeTwo"
            v-show="controlsStatus == 2"
            v-loading="uploadFileLoading"
          >
            <mini-audio
              v-if="audioUrl"
              :audio-source="audioUrl"
              class="audio_class"
            ></mini-audio>
            <div
              style="
                width: 32px;
                height: 32px;
                margin-left: 20px;
                cursor: pointer;
                background-color: #3681fc;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
              "
              @click="onClickStartRecord()"
            >
              <img
                style="width: 10px; height: 16px"
                src="../../../../assets/icon/classroomObservation/mai1.svg"
                alt=""
              />
            </div>
          </div>
          <div
            class="ca-b-o-m-inputAre"
            v-show="controlsStatus == 3"
            v-loading="textareaLoading"
          >
            <div class="ca-b-o-m-left">
              <textarea
                id="myTextarea"
                ref="textareaRef"
                min-rows="1"
                max-rows="5"
                v-model="textareaValue"
                placeholder="在此输入您想了解的内容"
                autosize="none"
                @input="textareaChange"
                @change="textareaChange"
                @keydown="textareaKeydown"
              ></textarea>
            </div>
            <div class="ca-b-o-m-right">
              <!-- <span @click.stop="tapeSubmit()"></span> -->
              <!-- <div :class="sendBtnDsiable ? 'ca-b-o-m-r-dsiableBtn' : ''">
								发送
							</div> -->
              <el-button
                :disabled="textareaValue.trim().length == 0"
                type="primary"
                size="mini"
                @click="send()"
                >发送</el-button
              >
            </div>
            <div
              ref="roleListRef"
              v-click-outside="noShowRoleList"
              class="ca_b_o_m_roleList"
              v-if="showRoleList && choseRoleList.length != 0"
            >
              <div
                :class="[
                  'ca_b_o_m_rl_item',
                  roleListIndex == index ? 'ca_b_o_m_rl_itemActive' : ''
                ]"
                v-for="(item, index) in choseRoleList"
                :key="item.assistant_id"
                @click="choseRole(item)"
                @mouseover="() => (roleListIndex = index)"
              >
                <div class="ca_b-o_m_rl_i_top">
                  <el-avatar
                    size="medium"
                    :src="
                      item.headUrl
                        ? item.headUrl
                        : require('@/assets/icon/classroomObservation/aiAvatar.png')
                    "
                  ></el-avatar>
                  <div>
                    <div>{{ item.assistantName }}</div>
                    <span v-if="item.username">作者：{{ item.username }}</span>
                  </div>
                </div>
                <div class="ca_b-o_m_rl_i_bottom">
                  <span>{{ item.description }}</span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="ca-b-o-m-TapeArea"
            v-show="controlsStatus == 1"
            v-loading="uploadFileLoading"
          >
            <div class="ca-b-o-m-i-left">
              <img
                style="height: 120%"
                src="@/assets/icon/classroomObservation/isTape.svg"
                alt=""
              />
              <div>
                <div v-if="recordedForm.status == 1" style="color: #ee3e3e">
                  录音中...
                </div>
                <div v-if="recordedForm.status == 2" style="color: #6b798e">
                  已暂停...
                </div>
                <span>{{ recordedForm.time }}</span>
              </div>
            </div>
            <!-- <img
							style="height: 120%"
							src="@/assets/icon/classroomObservation/tapetime.png"
							alt=""
						/> -->
            <div
              style="width: 100px; display: flex; justify-content: space-between"
            >
              <div
                class="lyStart"
                @click="onClickPauseOrContinueRecord()"
                v-loading="recordedForm.loading"
              >
                <img
                  style="width: 12px; height: 12px"
                  src="@/assets/icon/classroomObservation/lyStart.svg"
                  alt=""
                  v-if="recordedForm.status == 1"
                />
                <img
                  style="width: 12px; height: 12px"
                  src="@/assets/icon/classroomObservation/start.png"
                  alt=""
                  v-if="recordedForm.status == 2"
                />
              </div>
              <div
                class="lyStart"
                @click="onClickFinishRecord()"
                v-loading="recordedForm.loading"
              >
                <img
                  style="width: 12px; height: 12px"
                  src="@/assets/icon/classroomObservation/lyStop.svg"
                  alt=""
                />
              </div>
            </div>
            <!-- <div class="ca-b-o-m-left">
							<textarea :value="textareaValue" autosize="none"></textarea>
						</div>
						<div class="ca-b-o-m-right">
							<span @click.stop="tapeSubmit()"></span>
							<div :class="sendBtnDsiable ? 'ca-b-o-m-r-dsiableBtn' : ''">
								发送
							</div>
						</div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 录音转文字 -->
    <iframe
      allow="camera *; microphone *;display-capture;midi;encrypted-media;"
      src="https://beta.cloud.cocorobo.cn/browser/public/index.html"
      ref="iiframe"
      v-show="false"
    ></iframe>
    <div class="chatAreaLoading" v-if="progressData.uploadLoading">
      <div class="cal_box">
        <div>
          <img :src="require('../../../../assets/loading.gif')" alt="" />
          <span>上传中，请稍等...</span>
        </div>
        <el-progress
          style="width: 100%; color: #fff"
          :text-inside="true"
          :stroke-width="24"
          :percentage="progressData.value"
        ></el-progress>
      </div>
      <!-- <el-progress style="width:80%" :text-inside="true" :stroke-width="24" :percentage="progressData.value"></el-progress> -->
    </div>
    <div class="chatAreaLoading" v-else-if="jobContext">
      <div class="cal_box" :style="{ height: 'fit-content' }">
        <el-progress
          type="circle"
          :percentage="jobContext.progress.percentage"
          :color="jobContext.status === 'paused' ? '#ff4949' : '#20a0ff'"
          :format="
            () => `${jobContext.progress.current}/${jobContext.progress.total}`
          "
        ></el-progress>
        <span v-if="jobContext.status === 'paused' && jobContext.error">{{
          jobContext.error
        }}</span>
        <div :style="{ display: 'flex' }">
          <el-button
            v-if="jobContext.status === 'paused'"
            @click="() => jobContext.restart()"
            icon="el-icon-video-play"
            type="primary"
          >
            继续
          </el-button>
          <!-- <el-button
            v-if="jobContext.status === 'running'"
            icon="el-icon-video-pause"
            @click="() => jobContext.pause()"
            >暂停</el-button
          > -->
          <el-button
            type="danger"
            icon="el-icon-switch-button"
            @click="() => jobContext.stop()"
            >终止</el-button
          >
        </div>
      </div>
      <!-- <el-progress style="width:80%" :text-inside="true" :stroke-width="24" :percentage="progressData.value"></el-progress> -->
    </div>
    <addNewTeacherVoiceprintDialog
      ref="addNewTeacherVoiceprintDialogRef"
      @complete="loadVoiceprints"
    />
  </div>
</template>

<script>
import startPage from "./startPage";
import transcription from "./transcription";
import tape from "./tape";
import { v4 as uuidv4 } from "uuid";
import MarkdownIt from "markdown-it";
import EditorBar from "./wangEnduit";
const lamejs = require("lamejs");
import vpdf from "./vpdf";
import _ from "lodash";
import Papa from "papaparse";
import addNewTeacherVoiceprintDialog from "./addNewTeacherVoiceprintDialog.vue";
import * as Sy from "@/lib/shengyang";
import Recorder from "recorder-core/recorder.mp3.min";

// import { saveAs } from "file-saver";

// import Recorder from 'recorder-core/recorder.wav.min'

const OPTIONS_GROUP = {
  default: [
    "老师讲课",
    "老师提问或点名",
    "老师板书或操作",
    "老师评价或反馈",
    "老师其他",
    "学生发言",
    "学生小组活动",
    "学生自主学习",
    "学生汇报分享",
    "学生其他"
  ]
};
const ATTENTION_GROUP = {
  default:
    "- 先根据说话人角色判断，再在对应角色的选项中选择选项\n- 如果没有合适的选项，默认使用`老师其他`或者`学生其他`"
};
const ROLE_OPTIONS_GROUP = {
  default: ["老师", "学生"]
};

// 自定义指令，用于处理点击外部区域的事件
const clickOutside = {
  bind(el, binding) {
    // 在元素上绑定一个点击事件监听器
    el.clickOutsideEvent = function(event) {
      // 检查点击事件是否发生在元素的内部
      if (!(el === event.target || el.contains(event.target))) {
        // 如果点击事件发生在元素的外部，则触发指令绑定的方法,将点击的event数据传过去
        binding.value(event);
      }
    };
    // 在文档上添加点击事件监听器
    document.addEventListener("click", el.clickOutsideEvent);
  },
  unbind(el) {
    // 在元素上解除点击事件监听器
    document.removeEventListener("click", el.clickOutsideEvent);
  }
};

const getFile = url => {
  return new Promise((resolve, reject) => {
    var credentials = {
      accessKeyId: "AKIATLPEDU37QV5CHLMH",
      secretAccessKey: "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"
    }; //秘钥形式的登录上传
    window.AWS.config.update(credentials);
    window.AWS.config.region = "cn-northwest-1"; //设置区域
    let url2 = url;
    let _url2 = "";
    if (
      url2.indexOf("https://view.officeapps.live.com/op/view.aspx?src=") != -1
    ) {
      _url2 = url2.split(
        "https://view.officeapps.live.com/op/view.aspx?src="
      )[1];
    } else {
      _url2 = url2;
    }
    var s3 = new window.AWS.S3({ params: { Bucket: "ccrb" } });
    let name = decodeURIComponent(
      _url2.split("https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/")[1]
    );
    var params = {
      Bucket: "ccrb",
      Key: name
    };
    s3.getObject(params, function(err, data) {
      if (err) {
        console.log(err, err.stack);
        resolve({ data: 1 });
      } else {
        const fileContent = data.Body.toString("utf-8");
        resolve({ data: fileContent });
      } // sxuccessful response
    });
    // axios({
  });
};
export default {
  emits: ["updateFileId", "changeAudioUrl", "updateTranscription"],
  props: {
    tid: {
      type: String,
      require: true
    },
    fileId: {
      type: String,
      default: ""
    },
    fileIdId: {
      type: String,
      default: ""
    },
    createTime: {
      type: String,
      default: new Date().toLocaleString().replaceAll("/", "-")
    }
  },
  components: {
    startPage,
    transcription,
    tape,
    EditorBar,
    vpdf,
    addNewTeacherVoiceprintDialog
  },
  directives: {
    "click-outside": clickOutside // 注册自定义指令
  },
  data() {
    return {
      // continuousDialogue: true,
      controlsStatus: 0, //0--点击开始录音  1--录音中   2--录音完毕预览  3--文字输入
      pageStatus: 0, //0--ai对话  1--原文文稿  2--转录文稿
      showIndexPage: true, //是否显示初始页面
      languageRadio: 2, //设置选择语言
      languageShow: false, //控制显示
      loading: false,
      chatLoading: false,
      transcriptionLoading: false,
      uploadFileLoading: false,
      editorBarLoading: false,
      textareaValue: "",
      textareaLoading: false,
      showRoleList: false,
      showGetTextLoading: false,
      wavGetTextLoading: false,
      wavGetTextProgress: 0,
      roleListIndex: 0,

      userId: this.$route.query["userid"],
      recordedForm: {
        time: "00:00:00", //时间
        status: 0, //0--未录音  1--正在录音  2--暂停  3--录音结束
        timer: null,
        timeDuration: 0,
        audioBlob: [],
        startTime: 0,
        endTime: 0,
        textList: [],
        loading: false
      },
      roleList: [],
      publicRoleList: [],
      progressData: {
        uploadLoading: false,
        value: 0
      },
      audioUrl: "",
      editorBarData: {
        type: "0", //0---文字   1-文件
        content: "",
        url: ""
      },
      // 设置list
      languageList: [
        { label: 2, lang: "普通话" },
        { label: 3, lang: "粤语" },
        { label: 13, lang: "英语" }
      ],
      // 语音文字list
      tapeList: [
        {
          ico: require("@/assets/icon/classroomObservation/mai1.svg"),
          ico1: require("@/assets/icon/classroomObservation/mai2.svg")
        },
        {
          ico: require("@/assets/icon/classroomObservation/wen1.svg"),
          ico1: require("@/assets/icon/classroomObservation/wen2.svg")
        }
      ],
      titBarList: [
        {
          title: "Al对话",
          ico: require("@/assets/icon/classroomObservation/Group9101.svg"),
          ico1: require("@/assets/icon/classroomObservation/Group9102.svg")
        },
        {
          title: "原文速览",
          ico1: require("@/assets/icon/classroomObservation/Vector.svg"),
          ico: require("@/assets/icon/classroomObservation/Vector2.svg")
        },
        {
          title: "转录文稿",
          ico1: require("@/assets/icon/classroomObservation/zhuanlu.svg"),
          ico: require("@/assets/icon/classroomObservation/zhuanlu2.svg")
        }
      ],
      transcriptionData: {
        content: ""
      },
      chatList: [],
      actionTypesMap: {},
      jobContext: null,
      showTeacherVoiceprintBox: false,
      teacherVoiceprintList: [],
      chosenVoiceprint: [],
      recorderProvider: "shengyang",
      shengyangContext: {
        recorder: null,
        ws: null
      },
      userName: ""
    };
  },
  computed: {
    // 选择可以@的角色
    choseRoleList() {
      let result = [...this.roleList, ...this.publicRoleList];
      const _index = this.textareaValue.lastIndexOf("@");
      if (_index !== -1) {
        let roleName = this.textareaValue.substring(_index + 1);
        result = result.filter(i => i.assistantName.indexOf(roleName) != -1);
      } else {
        return [];
      }
      return result;
    }
  },
  watch: {
    choseRoleList() {
      this.roleListIndex = 0;
    },
    tid: {
      async handler(tid) {
        if (!tid) {
          this.actionTypesMap = undefined;
          return;
        }
        this.actionTypesMap = await this.loadActionTypesMap();
        if (!this.actionTypesMap) {
          const res = await this.insertActionTypes();
          this.actionTypesMap = await this.loadActionTypesMap();
        }
      },
      immediate: true
    }
  },
  methods: {
    handleBlur(event) {
      // console.log("点击其它区域啦", event);
      this.languageShow = !this.languageShow;
    },
    // 上传录音
    uploadRecording() {
      if (!this.tid) {
        return this.$parent.addNewCourse().then(_ => {
          this.uploadRecording();
        });
      }
      if (this.uploadFileLoading) return this.$message.info("请稍等...");
      let input = document.createElement("input");
      input.type = "file";
      // input.accept = ".wav";
      // input.accept = "audio/*, .txt, .pdf, .xlsx";
      input.accept = ".mp3,.wav,.txt,.pdf,.xlsx,.doc,.docx,.csv";
      input.click();
      input.onchange = () => {
        this.uploadFileLoading = true;
        let file = input.files[0];
        if (!/\.(mp3|wav|txt|pdf|xlsx|doc|docx|csv)$/i.test(file.name)) {
          this.uploadFileLoading = false;
          return this.$message.info(
            "请上传.mp3,.wav,.txt,.pdf,.xlsx,.doc,.docx,.csv格式的文件"
          );
        }
        this.uploadFile(file, { changeText: true, flag: true });
        // this.uploadWavFileAndGetText(file);
      };
    },
    getVideoAudioSuccess(file) {
      this.uploadFile(file, { changeText: true, flag: true });
    },
    cutBar(val) {
      this.pageStatus = val;
      if (this.pageStatus == 0) {
        //ai对话
        this.controlsStatus = 3;
      } else if (this.pageStatus == 1 || this.pageStatus == 2) {
        // 原文速览&&转录文稿

        if ([1, 2].includes(this.recordedForm.status)) {
          this.controlsStatus = 1;
        } else {
          this.controlsStatus = 2;
        }
      }
      this.showIndexPage = false;
    },
    cutTape(val) {
      if (val == 0) {
        if ([1, 2].includes(this.recordedForm.status)) {
          this.controlsStatus = 1;
          this.showIndexPage = true;
        } else if (this.audioUrl) {
          this.controlsStatus = 2;
          this.pageStatus = 1;
        } else {
          this.controlsStatus = 0;
          this.showIndexPage = true;
        }
      } else if (val == 1) {
        // if (this.pageStatus == 0) {
        //ai对话
        this.pageStatus = 0;
        this.controlsStatus = 3;
        // } else if (this.pageStatus == 1 || this.pageStatus == 2) {
        // 	// 原文速览&&转录文稿
        // 	this.controlsStatus = 2;
        // }
        this.showIndexPage = false;
      } else if (val == 2) {
        this.controlsStatus = 0;
        this.showIndexPage = true;
      }
    },
    updateRecordedTime({ duration }) {
      // 更新currentTime，将秒数转换为时分秒格式
      let hours = Math.floor(duration / 3600);
      let minutes = Math.floor((duration % 3600) / 60);
      let seconds = Math.floor(duration % 60);
      // this.recordedForm.time = `${hours.toString().padStart(2, "0")}:${minutes
      // 	.toString()
      // 	.padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
      return `${hours
        .toString()
        .padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    },
    //切换观察
    // changeAnalysis() {
    // 	this.$message.info("切换观察");
    // },
    // 切换连续对话
    changeContinuousDialogue(newValue) {
      this.continuousDialogue = newValue;
    },
    changeAudioUrl(newValue) {
      if (!newValue) return;
      this.audioUrl = newValue;
      if (![1, 2].includes(this.pageStatus)) this.pageStatus = 1;
      this.controlsStatus = 2;
      this.showIndexPage = false;
    },
    // 发送消息
    send(_text = this.textareaValue) {
      var OpenCC = require("opencc-js");
      let converter = OpenCC.Converter({
        from: "cn",
        to: "hk"
      });
      this.textareaValue = "";
      // 判断输入的文本是否为空
      if (!_text.trim()) return;
      // 这里处理@的角色
      let _atRoleList = [];
      let _roleList = [...this.roleList, ...this.publicRoleList];
      _roleList.forEach(i => {
        if (_text.indexOf(`@${i.assistantName}`) != -1) {
          _atRoleList.push(i);
        }
      });
      if (_atRoleList.length > 0) {
        //有@角色
        let _replaceText = _text;
        let _htmlText = _text;
        _atRoleList.forEach(_i => {
          _replaceText = _replaceText.replaceAll(`@${_i.assistantName}`, ``);
          _htmlText = _htmlText.replaceAll(
            `@${_i.assistantName}`,
            `<span class='aite-name'>@${_i.assistantName}</span>`
          );
        });
        _atRoleList.forEach((_item, _index) => {
          const _uid = uuidv4();
          if (_index == 0) {
            this.chatList.push({
              loading: true,
              role: "user",
              content: _htmlText,
              uid: _uid,
              AI: "AI",
              aiContent: "",
              oldContent: "",
              isShowSynchronization: false,
              filename: _item.headUrl,
              index: this.chatList.length,
              is_mind_map: false,
              fileid: _item.assistantName,
              createtime: new Date().toLocaleString().replaceAll("/", "-")
            });
          } else {
            this.chatList.push({
              loading: true,
              role: "user",
              content: "",
              uid: _uid,
              AI: "AI",
              aiContent: "",
              oldContent: "",
              isShowSynchronization: false,
              filename: _item.headUrl,
              index: this.chatList.length,
              is_mind_map: false,
              fileid: _item.assistantName,
              createtime: new Date().toLocaleString().replaceAll("/", "-")
            });
          }
          this.scrollBottom();
          let params = {
            assistant_id: _item.assistant_id,
            userId: this.userId,
            message: _replaceText,
            session_name: `${this.tid}-classroomObservation`,
            uid: _uid,
            file_ids: this.fileId ? [this.fileId] : [],
            model: "gpt-4o-2024-11-20"
          };
          this.ajax
            .post("https://gpt4.cocorobo.cn/ai_agent_park_chat_new", params)
            .then(res => {
              if (
                converter(res.data.FunctionResponse.result) ==
                converter("发送成功")
              ) {
              } else {
                this.$message.warning(res.data.FunctionResponse.result);
              }
            })
            .catch(err => {
              console.log(err);
            });
          this.getAtAuContent(
            _uid,
            _htmlText,
            _item.headUrl,
            _item.assistantName
          );
        });
      } else {
        //未@角色

        let _uuid = uuidv4();
        this.chatList.push({
          role: "user",
          content: `${_text}`,
          uid: _uuid,
          AI: "AI",
          aiContent: "",
          oldContent: "",
          isShowSynchronization: false,
          filename: "",
          index: this.chatList.length,
          is_mind_map: false,
          createtime: new Date().toLocaleString().replaceAll("/", "-"),
          loading: true
        });
        this.scrollBottom();
        // 连续对话设置
        let _historyMessage = [];
        // this.chatList.forEach(i=>{

        // })
        _historyMessage.push({ role: "user", content: _text });
        let params = JSON.stringify({
          model: "gpt-4o-2024-11-20",
          temperature: 0,
          max_tokens: 4096,
          top_p: 1,
          frequency_penalty: 0,
          presence_penalty: 0,
          messages: _historyMessage,
          uid: _uuid,
          mind_map_question: ""
        });
        // let params = JSON.stringify({
        // 	message: {
        // 		anthropic_version: "bedrock-2023-05-31",
        // 		max_tokens: 4096,
        // 		temperature: 0,
        // 		top_p: 1,
        // 		messages: _historyMessage,
        // 	},
        // 	uid: _uuid,
        // 	model: "Claude 3 Sonnet", // Claude 3 Sonnet或者Claude 3 Haiku
        // });

        this.ajax
          .post("https://gpt4.cocorobo.cn/chat", params)
          // .post("https://claude3.cocorobo.cn/chat", params)
          .then(res => {
            if (
              converter(res.data.FunctionResponse.result) ==
              converter("发送成功")
            ) {
            } else {
              this.$message.warning(res.data.FunctionResponse.result);
            }
          })
          .catch(e => {
            console.log(e);
          });
        this.getAiContent(_uuid);
      }
    },
    getAiContent(_uid) {
      // let _source = new EventSource(
      // 	`https://claude3.cocorobo.cn/streamChat/${_uid}`
      // );
      let _source = new EventSource(`https://gpt4.cocorobo.cn/stream/${_uid}`); //http://gpt4.cocorobo.cn:8011/stream/     https://gpt4.cocorobo.cn/stream/
      let _allText = "";
      let _mdText = "";
      const md = new MarkdownIt();
      _source.onmessage = _e => {
        if (_e.data.replace("'", "").replace("'", "") == "[DONE]") {
          //对话已经完成
          _mdText = _mdText.replace("_", "");
          _source.close();
          this.chatList.find(i => i.uid == _uid).aiContent = _mdText;
          this.chatList.find(i => i.uid == _uid).isalltext = true;
          this.chatList.find(i => i.uid == _uid).isShowSynchronization = true;
          this.chatList.find(i => i.uid == _uid).loading = false;
          this.insertChat(_uid);
          return;
        } else {
          //对话还在继续
          let _text = "";
          _text = _e.data.replaceAll("'", "");
          if (_allText == "") {
            _allText = _text.replace(/^\n+/, ""); //去掉回复消息中偶尔开头就存在的连续换行符
          } else {
            _allText += _text;
          }
          _mdText = _allText + "_";
          _mdText = _mdText.replace(/\\n/g, "\n");
          _mdText = _mdText.replace(/\\/g, "");
          if (_allText.split("```").length % 2 == 0) _mdText += "\n```\n";
          //转化返回的回复流数据
          _mdText = md.render(_mdText);
          this.chatList.find(i => i.uid == _uid).aiContent = _mdText;
          this.chatList.find(i => i.uid == _uid).loading = false;
          this.scrollBottom();
          // 处理流数据
        }
      };
    },
    getAtAuContent(_uid, _text, _headUrl, _assistantName) {
      let _source = new EventSource(
        `https://gpt4.cocorobo.cn/question/${_uid}`
      ); //http://gpt4.cocorobo.cn:8011/question/   https://gpt4.cocorobo.cn/question/
      let _allText = "";
      let _mdText = "";
      const md = new MarkdownIt();
      _source.onmessage = _e => {
        let _eData = JSON.parse(_e.data);
        if (_eData.content.replace("'", "").replace("'", "") == "[DONE]") {
          let _result = [];
          if ("result" in _eData) {
            _result = _eData.result;
            for (let i = 0; i < _result.length; i++) {
              _mdText = _mdText.replace(_result[i].text, _result[i].fileName);
            }
          }
          _mdText = _mdText.replace("_", "");
          this.chatList.find(i => i.uid == _uid).aiContent = _mdText;
          this.chatList.find(i => i.uid == _uid).isalltext = true;
          this.chatList.find(i => i.uid == _uid).isShowSynchronization = true;
          this.chatList.find(i => i.uid == _uid).loading = false;
          this.scrollBottom();
          this.insertChat(_uid);
        } else {
          let _text = _eData.content.replace("'", "").replace("'", "");
          if (_allText == "") {
            _allText = _text.replace(/^\n+/, ""); //去掉回复消息中偶尔开头就存在的连续换行符
          } else {
            _allText += _text;
          }
          _mdText = _allText + "_";
          _mdText = _mdText.replace(/\\n/g, "\n");
          _mdText = _mdText.replace(/\\/g, "");
          if (_allText.split("```").length % 2 == 0) _mdText += "\n```\n";
          //转化返回的回复流数据
          _mdText = md.render(_mdText);
          this.chatList.find(i => i.uid == _uid).aiContent = _mdText;
          this.chatList.find(i => i.uid == _uid).loading = false;
          this.scrollBottom();
          // 处理流数据
        }
      };
    },
    textareaChange() {
      if (this.textareaValue.at(-1) == "@") {
        this.showRoleList = true;
      }
      this.$refs.textareaRef.style.height = "50px";
      this.$refs.textareaRef.style.height =
        this.$refs.textareaRef.scrollHeight + "px";
      if (this.$refs.roleListRef) {
        let roleListHeight =
          this.$refs.textareaRef.scrollHeight >= 500
            ? 520
            : this.$refs.textareaRef.scrollHeight + 20;
        this.$refs.roleListRef.style["margin-bottom"] = "70px";
        this.$refs.roleListRef.style["margin-bottom"] = roleListHeight + "px";
        this.$refs.roleListRef.style[
          "max-height"
        ] = `calc(100vh - ${roleListHeight + 160}px)`;
      }
    },
    // 滚动条触底
    scrollBottom() {
      this.$nextTick(() => {
        this.textareaChange();
        this.$refs.tapeRef.$el.querySelector(
          ".t-chartArea"
        ).scrollTop = this.$refs.tapeRef.$el.querySelector(
          ".t-chartArea"
        ).scrollHeight;
      });
    },
    // 点击了其他地方然后关闭角色列表
    noShowRoleList() {
      this.showRoleList = false;
    },
    getBehaviorCoding(list) {
      let start = 0;
      let end = 0;
      let _pList = [];
      let _step = 9999999999999999999;
      let promiseList = [];
      for (let i = 0; i <= list.length - 1; i++) {
        _pList.push(list[i]);
        if (i == 0) continue;
        if (i % _step == 0) {
          end = i;
          promiseList.push(
            this.getBehaviorCodingPromise(start, end, _pList).then(_res => {
              let { startIndex, endIndex, data } = _res;
              data.forEach((item2, index2) => {
                list[startIndex + index2].aiBehavior = item2;
              });
              // let
            })
          );
          _pList = [];
          start = i;
          continue;
        }
        if (i == list.length - 1) {
          end = i;
          promiseList.push(
            this.getBehaviorCodingPromise(start, end, _pList).then(_res => {
              let { startIndex, endIndex, data } = _res;
              console.log("promise👉", _res);
              data.forEach((item2, index2) => {
                list[startIndex + index2].aiBehavior = item2;
              });
            })
          );
          _pList = [];
          start = i;
          break;
        }
      }
      Promise.all(promiseList).then(_ => {
        console.log("👇");
        console.log(list);
      });

      // list.forEach((item,index)=>{
      // 	if(index==0){
      // 		start = 0;
      // 		end = 0;
      // 		_pList = [];
      // 	}

      // })
    },
    getBehaviorCodingPromise(start, end, list) {
      return new Promise((resolve, reject) => {
        let _uuid = uuidv4();
        let _workText = "";
        let _list = [];
        list.forEach(i => {
          _list.push({
            index: i.index,
            message: i.message,
            time: i.time,
            role: i.role,
            behavior: ""
          });
        });
        // list.forEach(i=>{
        // 	_workText+=`${i.message} ${i.time} ${i.role}\n`
        // })
        let _msg = `Language: Please use the same language as the user requirement, if the user speaks Chinese, the specific text of your answer should also be in Chinese.
ATTENTION: Use '##' to SPLIT SECTIONS, not '#'. Output format carefully referenced "Format example".
Instruction: Based on the context, follow "Format example", write content

请你基于以下{用户给定的文本}，执行以下任务，按要求输出对应内容。

## 角色

你是专业的课堂行为分析员，熟悉课堂行为编码的标准和分类，能够准确识别和标注课堂中的各种行为。

## 任务

根据用户给定的文本和文本上下文背景，为用户提供的每一行文本，打上相应的行为编码的标签。输出行为编码的名称，以及你的判断理由。严格按照指定的格式输出编码名称，请仅仅只是输出编码名称，无需任何其它的解释性文字。

## 工作流程

1. 仔细阅读并分析用户提供的文本。
2. 仔细阅读用户指定的某一行文本，结合上下文，参考知识库中的编码特征描述，为该行文本打上相应的行为编码标签。
3. 严格按照指定的格式输出编码名称，请仅仅只是输出编码名称，无需任何其它的解释性文字。


## 知识库

### 简单版本的编码特征描述

每个编码类型的名字、评价标准、语言学特征，以及相应的课堂实例。

| 行为编码       | 评价标准                                               | 语言学特征                                                   | 课堂实例                                                     |
| -------------- | ------------------------------------------------------ | ------------------------------------------------------------ | ------------------------------------------------------------ |
| 老师讲课       | 老师进行知识传授、活动安排、总结等。                   | 使用陈述句，语气平稳，内容多为知识传授、活动安排、总结等。   | 1.' '好了，接下来我们进行一个小实验，请大家按照步骤操作'。' <br> 2.' '那孩子们仔细看老师的手指，十个手指中有一些指向陆地，有一些指向海洋'。' <br> 3.' '现在我随机把这个球传给我们班上的任意1位同学，请你数数几个陆地几个海洋'。' |
| 老师提问或点名 | 老师提问学生或点名学生回答问题。                       | 使用疑问句或指令性语言，语气较为引导，内容多为提问或点名。   | 1.' '请你说'。' <br> 2.' '请你帮我数一数有多少个陆地，多少个海洋'。' <br> 3.' '那这个时候我们可以怎么办？这些困难又会给我们带来什么样的启发呢？'' |
| 老师板书或操作 | 老师在黑板上书写或进行实验操作。                       | 使用描述性语言和指令性语言，语气较为平稳，内容多为书写或操作指令。 | 1.' '请大家看黑板，这里是我们今天要学习的重点'。' <br> 2.' '接下来我们进行一个小实验，请大家按照步骤操作'。' <br> 3.' '我现在在黑板上写下这个公式，大家要记住'。' |
| 老师评价或反馈 | 老师对学生的回答或表现进行评价或反馈。                 | 使用评价性语言和反馈性语言，语气较为鼓励，内容多为评价或反馈。 | 1.' '所以你是个观察仔细的同学，请坐'。' <br> 2.' '你是一个善于思考的孩子'。' <br> 3.' '非常好的方法'。' |
| 老师其它       | 老师进行与课堂内容相关的其他活动。                     | 使用描述性语言和指令性语言，语气较为活泼，内容多为活动描述或操作指令。 | 1.' '这实在是太有趣了，原来失重使太空与地球之间的生活形成了如此大的差别'。' <br> 2.' '请大家自由编创，同学们可以想一想'。' <br> 3.' '我们将白玫瑰横向剪开，再纵向剪开，观察茎的内部结构'。' |
| 学生发言       | 学生在课堂上进行简短的发言或回答老师的问题。           | 使用简短的陈述句或疑问句，语气较为随意，内容多为回答问题或简短发言。 | 1.' '我觉得是一号'。' <br> 2.' '因为一号比那个二号大好'。' <br> 3.' '因为呢海洋看上去面积更大'。' |
| 学生讨论       | 学生进行小组讨论或合作活动。                           | 使用讨论性语言和合作性语言，语气较为互动，内容多为讨论或合作。 | 1.' '请小评委们对照评价标准，小组内先讨论一下，可以站起来找同学说说你的想法'。' <br> 2.' '大家请看视频，先选取一朵白玫瑰，将水染色，把白玫瑰插入水中，等待一天'。' <br> 3.' '我们严格执行调查计划，通过百度、豆包等渠道搜集相关资料'。' |
| 学生小组活动   | 学生进行小组讨论或合作活动。                           | 使用讨论性语言和合作性语言，语气较为互动，内容多为讨论或合作。 | 1.' '请小评委们对照评价标准，小组内先讨论一下，可以站起来找同学说说你的想法'。' <br> 2.' '大家请看视频，先选取一朵白玫瑰，将水染色，把白玫瑰插入水中，等待一天'。' <br> 3.' '我们严格执行调查计划，通过百度、豆包等渠道搜集相关资料'。' |
| 学生自主学习   | 学生进行自主学习或独立完成任务。                       | 使用描述性语言和指令性语言，语气较为平稳，内容多为学习任务或指令。 | 1.' '请大家独立完成这道题目'。' <br> 2.' '现在大家可以开始阅读课本的第十页'。' <br> 3.' '请同学们在接下来的十分钟内完成这份练习'。' |
| 学生汇报分享   | 学生进行小组汇报、分享学习成果、展示活动成果等。       | 使用陈述句和描述性语言，语气较为正式，内容多为汇报、分享学习成果。 | 1.' '我们小组用了拼接法来比较海陆的面积'。' <br> 2.' '我们利用粘豆子的方法来比较海陆面积'。' <br> 3.' '我们采取数格子的方法比较海陆面积'。' |
| 学生其他       | 学生进行与课堂内容相关的其他活动，如表演、实验操作等。 | 使用描述性语言和指令性语言，语气较为活泼，内容多为活动描述或操作指令。 | 1.' '这实在是太有趣了，原来失重使太空与地球之间的生活形成了如此大的差别'。' <br> 2.' '请大家自由编创，同学们可以想一想'。' <br> 3.' '我们将白玫瑰横向剪开，再纵向剪开，观察茎的内部结构'。' |


### 行为编码详细的特征描述

#### 【老师讲课】的特征

老师的发言内容具有结构清晰、互动性强、鼓励参与、引导性强、教育性和启发性、反馈及时、语言简洁明了和注重细节等特征。这些特征有助于提高学生的参与度和学习效果，营造积极的课堂氛围。

1. **结构清晰**：发言内容按照时间顺序进行，逻辑性强，层次分明。老师先介绍活动背景和目的，然后逐步引导学生进行展示和互动，最后进行总结和评价。
2. **互动性强**：老师频繁与学生互动，鼓励学生提问、分享和展示。例如，老师多次邀请学生上台展示成果，并给予鼓励和表扬。
3. **鼓励参与**：老师通过掌声、表扬和鼓励性语言，激发学生的参与热情，增强他们的自信心。例如，老师多次使用“掌声欢迎”、“太棒了”等词语。
4. **引导性强**：老师在发言中起到了引导和组织的作用，明确活动的流程和要求，帮助学生更好地理解和参与活动。例如，老师详细说明了展示的内容和形式，并在每个环节进行引导。
5. **教育性和启发性**：发言内容不仅传授知识，还注重培养学生的思维能力和团队合作精神。例如，老师强调相互学习、汲取智慧、共同掌握知识等。
6. **反馈及时**：老师在学生展示和分享后，及时给予反馈和评价，帮助学生认识到自己的优点和不足。例如，老师在学生展示后进行点评，并表扬表现优秀的学生。
7. **语言简洁明了**：老师的发言内容简洁明了，易于学生理解和接受。例如，老师使用了大量简短的句子和明确的指令。
8. **注重细节**：老师在发言中关注细节，确保活动顺利进行。例如，老师提醒学生坐端正、认真听讲，并对每个环节进行详细说明。

#### 【老师提问或点名】的特征

老师的发言内容具有频繁提问、鼓励参与、引导思考、关注情感、鼓励表达和互动性强等特征。这些特征有助于激发学生的学习兴趣，增强课堂的互动性和参与度，促进学生的思考和表达能力。

1. **频繁提问**：老师在发言中频繁提问，涉及到学生的感受、意见和解决方案等。这种提问不仅包括直接的问题（如“谁来告诉我”、“你们想投给谁”），还包括引导学生思考和表达的开放性问题（如“这些困难又会给我们带来什么样的启发”）。
2. **鼓励参与**：老师通过提问和点名的方式，鼓励学生积极参与课堂活动。例如，老师多次邀请学生上台展示或汇报（如“有请繁星植物队”、“让我们有请小苗护卫队的同学上来汇报”）。
3. **引导思考**：老师的提问不仅仅是为了获取答案，更是为了引导学生进行深入思考。例如，老师在讨论植物成长过程中遇到的困难时，提出“这些困难又会给我们带来什么样的启发”，引导学生从问题中学习和反思。
4. **关注情感**：老师关注学生的情感和感受，询问他们的想法和感受（如“那两位小朋友这一次获得胜利有什么想说的吗”、“那你们愿意分享一下你们此时此刻的感受吗”）。这种关注有助于建立良好的师生关系，增强学生的课堂参与感。
5. **鼓励表达**：老师通过提问和点名，鼓励学生表达自己的观点和感受。例如，老师多次邀请学生举手发言，并给予积极的反馈（如“好非常棒还有吗”、“好支持”）。
6. **互动性强**：老师的发言内容具有很强的互动性，通过提问、点名和邀请学生上台等方式，增加了课堂的互动性和参与度。

#### 【老师评价或反馈 】的特征：

老师的发言内容具有高度的评价性、鼓励性和指导性，旨在通过正面反馈和具体建议帮助学生提升，同时激励他们在未来的学习和生活中继续努力和探索。

1. **频繁的评价和反馈**：老师在整个过程中频繁地对学生的表现进行评价和反馈。这些评价和反馈既有对具体表现的即时评价（如“缺少了节奏感”、“讲得很好”），也有对整体表现的总结性评价（如“非常感谢神探队的精彩分享”、“同学们种子舰队小组的分享很精彩”）。
2. **正面鼓励和表扬**：老师的发言中充满了正面的鼓励和表扬，强调学生的优点和进步。例如，“我要为种子建队小组点赞”、“你们在老师心目中是一样优秀的”、“希望你们在未来的学习和生活中学会用科学的方法去探索”。
3. **具体的改进建议**：除了表扬，老师也提供了具体的改进建议，帮助学生认识到需要改进的地方。例如，“缺少了节奏感”、“缺少了音乐”、“语速也很适中是吧”。
4. **激励和引导**：老师通过发言激励学生继续努力，并引导他们在未来的学习和生活中应用所学知识。例如，“希望你们在未来的学习和生活中学会用科学的方法去探索”、“要勇于探索，学以致用”。
5. **总结和过渡**：老师在不同环节之间进行总结和过渡，帮助学生理清思路，保持活动的连贯性。例如，“我们今天的汇报活动到此结束”、“下面的时间交给罗老师”。
6. **互动性**：老师的发言中有一定的互动性，鼓励学生参与和思考。例如，“大家觉得他们俩谁写的比较好呢”、“大家猜一猜”。

【】

#### 【老师其它】的特征：

无法归类为【老师讲课】【老师提问或点名】【老师评价或反馈】，则归类为【老师其它】。这类内容可能具备以下的特点：

1. **引导和组织**：老师在多个时段引导活动的进行，如邀请嘉宾、介绍活动内容、安排学生讨论和投票等。例如，序号417、418、425、548、549、722、723、724、725、763、794等。
2. **时间管理**：老师在发言中多次提到时间安排，确保活动按计划进行。例如，序号548、794等。
3. **信息传达**：老师在发言中传达了活动的背景、过程和结果，确保学生了解活动的每个环节。例如，序号544、545、546、547、766、769等。

---

#### 【学生发言】的特征：

学生的发言内容具有频繁且简短、重复和断续、描述和解释、讨论和建议、引用和推理、互动和回应以及内容多样性的特征。这些特征反映了学生在课堂讨论中的积极参与和多方面的思考。

1. **频繁且简短**：学生的发言内容多为简短的句子或片段，时长通常在几秒钟内。这表明学生们的发言较为频繁，但每次发言的内容较为简短。
2. **重复和断续**：有些发言内容存在重复和断续的现象，如“谁知谁知谁知谁知这个习惯的过程”、“4个4个”等。这可能反映了学生在表达时的思维跳跃或语言组织上的困难。
3. **描述和解释**：学生们经常描述某些现象或解释某些概念，如“海洋面积大于陆地面积”、“水可以帮助我们发电”等。这表明学生们在尝试通过语言来传达他们的理解和知识。
4. **讨论和建议**：学生们不仅仅是陈述事实，还会提出建议和进行讨论，如“我建议他们可以不要把两个陆地给重合了”、“因为他外他们有一些群岛就非常多的一些海洋就还是得接触一点”等。这显示了学生们在互动中积极参与并提出自己的见解。
5. **引用和推理**：有些发言内容引用了书本知识或进行了一些推理，如“我在科普书上看到过”、“如果没有了水的话就会非常的炎热”等。这表明学生们在发言时会结合已有的知识进行推理和论证。
6. **互动和回应**：学生们的发言中有不少是对他人发言的回应或互动，如“请你说”、“同意请坐”等。这显示了课堂上学生之间的互动性较强，发言不仅仅是单向的表达。
7. **多样性**：发言内容涉及多个主题和方面，从地理知识到水资源的用途，再到环境保护等，内容多样且广泛。这反映了学生们在课堂讨论中涉及的知识面较广。

#### 【学生小组活动】的特征：

1. **频繁重复**：发言中多次重复“数据”、“谁知”、“谢谢”等词语，显示出学生在表达过程中可能存在词汇匮乏或表达不清的情况。
2. **短促且断续**：大部分发言时长较短，通常在几秒钟内完成，且内容断续，缺乏连贯性。这可能反映了学生在小组活动中交流的即时性和随意性。
3. **非正式语言**：使用了大量口语化的表达，如“唉”、“嗯”、“啊”等，显示出学生在小组活动中的交流较为随意和非正式。
4. **任务导向**：尽管语言较为随意，但发言内容多与任务相关，如讨论数据、完成任务、粘贴结果等，表明学生在进行小组活动时仍然围绕着特定的任务展开。
5. **互动性强**：发言中多次出现对他人发言的回应和感谢，如“谢谢大家”、“谢谢谢谢”，显示出学生之间的互动频繁，合作性较强。
6. **信息量有限**：由于发言多为短句和重复，实际传递的信息量较为有限，可能需要更多的时间和交流来完成任务。

#### 【学生讨论】的特征：

发言内容显示出学生在讨论过程中可能存在表达不清、思路不明确、互动不足等问题，影响了讨论的有效性和信息传递的清晰度。

1. **频繁使用填充词**：发言中大量使用“嗯”、“谁知”等填充词，显示出说话者在表达过程中可能存在思考或犹豫。
2. **表达不清晰**：许多句子结构不完整，逻辑不连贯，难以理解具体意思。例如，“谁知谁知到时候谁知所以患者嗯谁知谁知嗯谁知嗯谁知嗯谁知谁知嗯嗯嗯谁知谁谁知他没有这个应该要做翻译”。
3. **重复和冗长**：发言中有大量重复的词语和短语，导致内容显得冗长且缺乏重点。例如，“谁知谁知谁知谁知谁知谁知谁知谁知”。
4. **缺乏具体信息**：大部分发言内容缺乏具体的、有意义的信息，更多的是一些模糊的、泛泛的表述。
5. **互动性低**：虽然是学生讨论，但从发言内容来看，互动性较低，更多是单方面的表达，缺乏有效的交流和回应。
6. **情绪表达**：偶尔有情绪表达的词语，如“谢谢”、“好好好”，但整体情绪表达不强烈。

#### 【学生汇报分享 】的特征：

1. **结构化和条理性**：学生的发言内容通常按照一定的逻辑顺序进行，先介绍方法，再给出数据，最后得出结论。例如，学生先介绍使用的方法（拼接法、粘豆子法、数格子法），然后提供具体的测量数据，最后总结出海洋面积大于陆地面积的结论。
2. **重复和确认**：在发言过程中，学生多次重复和确认数据和结论。这种重复不仅帮助巩固信息，也确保听众能够清楚理解。例如，学生多次确认陆地和海洋的重量或格子数。
3. **多样化的方法**：学生使用了多种方法来比较海陆面积，包括拼接法、粘豆子法和数格子法。这显示了学生在解决问题时的多样化思维和尝试不同方法的能力。
4. **数据驱动**：学生的发言内容高度依赖于具体的数据和计算结果。每个方法的介绍都伴随着具体的数值和计算过程，显示了学生对数据的重视和对结果的严谨态度。
5. **合作和综合**：学生在发言中提到综合不同小组的结果，显示了合作学习和综合分析的特征。例如，学生在总结时提到综合两个小组的结果得出结论。
6. **简洁明了**：学生的发言内容简洁明了，直接切入主题，避免了冗长的描述。这有助于听众快速抓住重点信息。

综上所述，【发言内容】具有内容丰富、结构清晰、互动性强、语言生动、注重实践、团队合作、教育意义和情感表达等特征，展示了学生们在科学探究和团队合作中的积极表现和学习成果。

#### 【学生其它】的特征：

无法归类为【学生发言】【学生小组活动】【学生讨论】【学生汇报分享】，则归类为【学生其它】。


## 数据

这是你需要打标签的特定的多行文本：
${JSON.stringify(_list)}

# Format example
[{index:1,message:"早上好",time:"00:00:2",role:"老师",behavior:"老师其它"},{index:2,message:"今天我们来学物理学",time:"00:00:5",role:"老师",behavior:"老师讲课"},{index:3,message:"有谁知道什么是物理吗",time:"00:00:3",role:"老师",behavior:"老师提问或点名"}]
`;
        console.log(_msg);
        let params = {
          assistant_id: "6063369f-289a-11ef-8bf4-12e77c4cb76b",
          userId: this.userId,
          // message:_msg,
          // message: [{role:"user",content:_msg}],
          message: [{ type: "text", text: _msg }],
          session_name: _uuid,
          // uid: _uuid,
          file_ids: [],
          model: "gpt-4o-2024-11-20"
        };

        this.ajax
          .post("https://gpt4.cocorobo.cn/ai_agent_park_chat", params)
          .then(res => {
            // let _data = res.data.FunctionResponse.choices[0].message.content;
            let _data = res.data.FunctionResponse.message;
            _data = _data.replaceAll("```json", "").replaceAll("```", "");
            // console.log(_data)
            // console.log(JSON.parse(_data))
            _data = JSON.parse(_data);
            console.log("👇");
            console.log(_data);
            console.log("👆");
            // resolve({startIndex:start,endIndex:end,data:_data})
          })
          .catch(err => {
            console.log(err);
            this.$message.error("行为编码错误");
          });
      });
    },
    // convertToMp3(wavDataView) {
    // 	// 获取wav头信息
    // 	const wav = lamejs.WavHeader.readHeader(wavDataView); // 此处其实可以不用去读wav头信息，毕竟有对应的config配置
    // 	const { channels, sampleRate } = wav;
    // 	const mp3enc = new lamejs.Mp3Encoder(channels, sampleRate, 128);
    // 	// 获取左右通道数据
    // 	const result = recorder.getChannelData();
    // 	const buffer = [];
    // 	const leftData =
    // 		result.left &&
    // 		new Int16Array(result.left.buffer, 0, result.left.byteLength / 2);
    // 	const rightData =
    // 		result.right &&
    // 		new Int16Array(result.right.buffer, 0, result.right.byteLength / 2);
    // 	const remaining = leftData.length + (rightData ? rightData.length : 0);
    // 	const maxSamples = 1152;
    // 	for (let i = 0; i < remaining; i += maxSamples) {
    // 		const left = leftData.subarray(i, i + maxSamples);
    // 		let right = null;
    // 		let mp3buf = null;
    // 		if (channels === 2) {
    // 			right = rightData.subarray(i, i + maxSamples);
    // 			mp3buf = mp3enc.encodeBuffer(left, right);
    // 		} else {
    // 			mp3buf = mp3enc.encodeBuffer(left);
    // 		}
    // 		if (mp3buf.length > 0) {
    // 			buffer.push(mp3buf);
    // 		}
    // 	}
    // 	const enc = mp3enc.flush();
    // 	if (enc.length > 0) {
    // 		buffer.push(enc);
    // 	}
    // 	return new Blob(buffer, { type: "audio/mp3" });
    // },
    async wavFileGetText(audioFile) {
			this.wavGetTextProgress = 0;
			let _TimeProgress = 6000;//六秒
			let _totalTime = 0;
			let _duration = 0;
      let flag = true;
      let textList = [];
      let _file = null;
      if (/\.(mp3)$/i.test(audioFile.name)) {
        _file = await this.convertMp3ToWav(audioFile);
      } else {
        _file = audioFile;
      }
     
      // this.uploadFile(_file,{changeText:false,flag:true})
      // return console.log(_file);

      console.log("将转录的文件👇");
      console.log(_file);

			const audio = new Audio(URL.createObjectURL(_file));
			audio.addEventListener("canplaythrough",()=>{
				_duration = (audio.duration * 1000).toFixed(0);
				console.log("音频时长",_duration)
			})


      try {
				let iiframe = this.$refs["iiframe"];
				let _this = this;
        this.wavGetTextLoading = true;
        iiframe.contentWindow.window.document.getElementById(
          "languageOptions"
        ).selectedIndex = this.languageRadio;
        _this.transcriptionData.content = "";
        iiframe.contentWindow.onRecognizedResult = function(e) {
          if (flag) {
            // 这里上传文件
            // _this.uploadWavFile(audioFile);
            _this.controlsStatus = 2;
            _this.showIndexPage = false;
            _this.pageStatus = 2;
            _this.editorBarData.type = "0";
            flag = false;
            _this.uploadFileLoading = false;
            _this.transcriptionData.content = "";
            _this.editorBarData.content = "";
            textList = [];
          }
					if(_this.wavGetTextProgress<=70){
						_TimeProgress = 6000;//六秒
					}else if(_this.wavGetTextProgress<=80){
						_TimeProgress = 4000;//改为三秒
					}else if(_this.wavGetTextProgress<=90){
						_TimeProgress = 2000;//改为一秒
					}else if(_this.wavGetTextProgress<95){
						_TimeProgress = 1000;//改为0.5秒
					}else if(_this.wavGetTextProgress<99){
						_TimeProgress = 500;//改为0.1秒
					}else{
						_TimeProgress = 0;//改为0秒不动
					}

					_totalTime+=_TimeProgress;
					_this.wavGetTextProgress = (_totalTime/_duration*100).toFixed(0);
          _this.wavGetTextLoading = true;
          _this.showGetTextLoading = true;
          let privText = e.privText;
          console.log("👇转译对象👇");
          console.log(e);
          console.log("👇转译结果👇");
          console.log(privText);
					if(!privText)return;
          textList.push({
            value: privText,
            startTime: "",
            endTime: "",
            time: ""
          });
          _this.transcriptionData.content += privText;

          let _result = `
				<table
						border="0"
						width="100%"
						cellpadding="0"
						cellspacing="0"
						style="text-align: center"
					>
						<tbody>
							<tr>
								<th>序号</th>
								<th>开始时间</th>
								<th>结束时间</th>
								<th>发言内容</th>
								<th>时长</th>
								<th>说话人身份</th>
								<th>行为编码</th>
						</tr>
				`;
          textList.forEach((item, index) => {
            _result += `<tr>
							<td>${index + 1}</td>
							<td></td>
							<td></td>
							<td>${item.value}</td>
							<td></td>
							<td></td>
							<td></td>
						</tr>`;
          });
          _result += `
				<tr>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
					</tbody>
				</table>`;
          _this.editorBarData.content = _result;
          // _this.editorBarData.content += privText;
        };

        iiframe.contentWindow.onSessionStopped = function(e) {
					_this.wavGetTextProgress = 100;
          if(_this.wavFileGetTextLoading)_this.$message.success("转译完成");
          _this.showGetTextLoading = false;
          _this.wavGetTextLoading = false;
          _this.saveEditorBar();
        };

        iiframe.contentWindow.doContinuousPronunciationAssessment("", {
          files: [_file]
        });
      } catch (error) {
				console.log(error)
        this.wavGetTextLoading = false;
        this.showGetTextLoading = false;
      }
    },
    stopWavGetText() {
      if (this.wavGetTextLoading) {
        try {
          let iiframe = this.$refs["iiframe"];
          iiframe.contentWindow.scenarioStopButton.click();
          this.wavGetTextLoading = false;
          this.showGetTextLoading = false;
					this.wavGetTextProgress = 0;
          this.$message.success("终止转译成功");
        } catch (error) {
          this.$message.error("终止转译失败");
        }
      } else {
        this.$message.error("转译未开始");
      }
    },
    uploadFile(file, { changeText = true, flag = true }) {
      var credentials = {
        accessKeyId: "AKIATLPEDU37QV5CHLMH",
        secretAccessKey: "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"
      }; //秘钥形式的登录上传
      window.AWS.config.update(credentials);
      window.AWS.config.region = "cn-northwest-1"; //设置区域

      var bucket = new window.AWS.S3({ params: { Bucket: "ccrb" } }); //选择桶
      var _this = this;

      if (file) {
        // this.loading = true;
        this.progressData.uploadLoading = true;
        this.progressData.value = 0;
        var params = {
          Key:
            file.name.split(".")[0] +
            new Date().getTime() +
            "." +
            file.name.split(".")[file.name.split(".").length - 1],
          ContentType: file.type,
          Body: file,
          "Access-Control-Allow-Credentials": "*",
          ACL: "public-read"
        }; //key可以设置为桶的相抵路径，Body为文件， ACL最好要设置
        var options = {
          partSize: 2048 * 1024 * 1024,
          queueSize: 2,
          leavePartsOnError: true
        };
        bucket
          .upload(params, options)
          .on("httpUploadProgress", function(evt) {
            //这里可以写进度条
            _this.progressData.value = parseInt((evt.loaded * 100) / evt.total);
            // console.log("Uploaded : " + parseInt((evt.loaded * 80) / evt.total) + '%');
          })
          .send(function(err, data) {
            if (err) {
              _this.$message.error("上传失败");
              _this.uploadFileLoading = false;
              _this.loading = false;
              _this.progressData.uploadLoading = false;
            } else {
              // 判断是不是音频文件
              const audioRegex = /\.(mp3|wav|ogg|flac|m4a)$/i;
              const txtRegex = /\.(txt|csv)$/i;
              const otherRegex = /\.(pdf|xlsx|doc|docx)$/i;
              // if (audioRegex.test(data.Location)) {
              // 	// console.log(data);
              // 	_this.uploadWavFileAndGetText(file)
              // 	_this.$emit("changeAudioUrl", data);

              // 	// console.log("修改音频文件");
              // 	// console.log(data)
              // 	_this.uploadFileLoading = false;
              // }else if(txtRegex.test(data.Location)){
              // 	console.log("这hi是一个txt文件")
              // } else if(otherRegex.test(data.Location)){
              //
              console.log(data.Location);
              if (audioRegex.test(data.Location)) {
                if (changeText) _this.wavFileGetText(file);
                _this.$emit("changeAudioUrl", data);
                _this.loading = false;
                _this.recordedForm.audioBlob = [];
                _this.recordedForm.time = "00:00:00";
                _this.recordedForm.timeDuration = 0;
                _this.progressData.uploadLoading = false;
                _this.recordedForm.textList = [];
                _this.saveEditorBar();
                return;
              }

              _this.ajax
                .put("https://gpt4.cocorobo.cn/upload_file_knowledge", {
                  url: data.Location
                })
                .then(res => {
                  let _data = res.data.FunctionResponse;
                  if (_data.result && _data.result.id) {
                    _this.$emit("updateFileId", _data.result.id);
                    // _this.$message.success("成功获取fileId");
                    _this.uploadFileLoading = false;
                    //处理文件
                    if (txtRegex.test(data.Location)) {
                      //txt
                      getFile(data.Location).then(_res => {
                        _this.controlsStatus = 2;
                        _this.showIndexPage = false;
                        _this.pageStatus = 2;
                        _this.editorBarData.type = "0";
                        // _this.transcriptionData.content = _res.data;
                        if (flag) {
                          const arr = Papa.parse(_res.data, {
                            header: false
                          }).data.slice(1);
                          console.log(arr);
                          const _editorBarDataContent = `<table
                          border="0"
                          width="100%"
                          cellpadding="0"
                          cellspacing="0"
                          style="text-align: center"
                        >
                          <tbody>
                            <tr>
                              <th>序号</th>
                              <th>开始时间</th>
                              <th>结束时间</th>
                              <th>发言内容</th>
                              <th>时长</th>
                              <th>说话人身份</th>
                              <th>行为编码</th>
                            </tr>
                            ${arr
                              .map(
                                row => `
                              <tr>
                                <td>${_.get(row, 0, "")}</td>
                                <td>${_.get(row, 1, "")}</td>
                                <td>${_.get(row, 2, "")}</td>
                                <td>${_.get(row, 3, "")}</td>
                                <td>${_.get(row, 4, "")}</td>
                                <td>${_.get(row, 5, "")}</td>
                                <td>${_.get(row, 6, "")}</td>
                              </tr>
                              `
                              )
                              .join("\n")}
                          </tbody>
                        </table>`;
                          _this.editorBarData.content = _editorBarDataContent;
                        } else {
                          _this.editorBarData.content = _res.data;
                        }
                        _this.editorBarData.url = "";
                        _this.saveEditorBar();
                      });
                    } else if (otherRegex.test(data.Location)) {
                      //pdf、 docx、doc、xlxs

                      _this.editorBarData.type = "1";
                      _this.editorBarData.url = data.Location;
                      _this.editorBarData.content = "";
                      _this.saveEditorBar();
                      // console.log("pdf、xlsx、doc、docx文件处理");
                    }
                    _this.loading = false;
                    _this.progressData.uploadLoading = false;
                    if (!_this.fileIdId) return;
                    // let pram2 = {
                    //   id: _this.fileIdId,
                    //   json_data: JSON.stringify({
                    //     file_ids: _data.result.id
                    //   })
                    // };
                    // _this.ajax
                    //   .post(
                    //     "https://gpt4.cocorobo.cn/update_classroom_observation",
                    //     pram2
                    //   )
                    //   .then(res => {});
                  } else {
                    _this.$message.error("修改fileId失败");
                  }

                  // this.$emit("updateFileId", data.Location)
                })
                .catch(e => {
                  _this.uploadFileLoading = false;
                  _this.progressData.uploadLoading = false;
                  console.log(e);
                  _this.$message.error("获取fileId失败");
                });
              // }

              // console.log(data.Location)
            }
          });
      }
    },
    // 录音转wav
    dataURLtoAudio(blob, filename) {
      return new File([blob], filename, { type: "audio/wav" });
    },
    getRoleList() {
      this.roleList = [];
      let params = {
        userId: this.userId
      };
      this.ajax
        .post("https://gpt4.cocorobo.cn/get_ai_agent_assistant_list", params)
        .then(res => {
          let _data = res.data.FunctionResponse.result;
          if (_data) {
            this.roleList = JSON.parse(_data);
          }
        })
        .catch(e => {
          console.log(e);
          // this.$message.error("获取角色列表失败");
          this.roleList = [];
        });
    },
    getPublicRoleList() {
      this.publicRoleList = [];
      let params = {
        userId: this.userId,
        organizeid: "45facc0a-1211-11ec-80ad-005056b86db5"
      };
      this.ajax
        .post(
          "https://gpt4.cocorobo.cn/get_ai_agent_assistant_share_list",
          params
        )
        .then(res => {
          let _data = res.data.FunctionResponse.result;
          if (_data) {
            this.publicRoleList = JSON.parse(_data);
          }
        })
        .catch(e => {
          this.publicRoleList = [];
          console.log(e);
          // console.log("获取公共角色失败", e);
        });
    },
    // 选择了@的角色
    choseRole(_data) {
      let _lastAtIndex = this.textareaValue.lastIndexOf("@");
      this.textareaValue = `${this.textareaValue.slice(0, _lastAtIndex)}@${
        _data.assistantName
      } `;
      this.$refs.textareaRef.focus();
      this.showRoleList = false;
    },
    // 输入框键盘按下监听
    textareaKeydown(_e) {
      if (this.showRoleList && this.choseRoleList.length > 0) {
        switch (_e.keyCode) {
          case 38: //小键盘上
            _e.preventDefault();
            if (this.roleListIndex == 0) return;
            this.roleListIndex--;
            // 修改滚动条高度
            this.$refs.roleListRef.scrollTop = this.roleListIndex * 105;
            break;
          case 40: //小键盘下
            _e.preventDefault();
            if (this.roleListIndex == this.choseRoleList.length - 1) return;
            this.roleListIndex++;
            this.$refs.roleListRef.scrollTop = this.roleListIndex * 105;
            break;
          case 13: //回车
            _e.preventDefault();
            this.choseRole(this.choseRoleList[this.roleListIndex]);
            break;
        }
      } else {
        if (_e.key === "Enter") {
          if (_e.altKey) {
            // 如果按下的是Alt+Enter，那么换行
            this.textareaValue += "\n";
          } else {
            this.send();
          }
        }
      }
    },
    getData() {
      if (!this.tid) return;
      this.loading = true;
      this.transcriptionData.content = "";
      (this.editorBarData = {
        type: "0", //0---文字   1-文件
        content: "",
        url: ""
      }),
        (this.audioUrl = "");
      this.chatList = [];
      this.getRoleList();
      this.getPublicRoleList();
      this.getChatList().then(_ => {
        this.loading = false;
        this.scrollBottom();
      });
    },
    // 保存转录文稿和原文速览
    saveEditorBar(flag = false) {
      if (!this.tid) return this.$message.error("请选择课堂");
      if (
        this.editorBarData.type == "0" &&
        flag &&
        this.editorBarData.content
      ) {
        // 如果是文本则转成txt并保存
        let _result = JSON.parse(JSON.stringify(this.editorBarData));
        var text = _result.content;

        // 创建一个Blob实例
        var blob = new Blob([text], { type: "text/plain;charset=utf-8" });
        blob.lastModifiedDate = new Date();
        blob.name = `${this.tid}-classroomObservation.txt`;
        return this.uploadFile(blob, { changeText: false, flag: false });
      } else {
        // this.loading = true;
        // let div = document.createElement("div");
        // div.innerHTML = this.editorBarData.content;
        // return this.loading = false;

        let _sentence = 0;
        let _words = 0;
        let _editorBarDataContentRows = [];
        let _actionTypes = [];

        if (this.editorBarData.type == 0) {
          let _data = this.editorBarData.content;
          let _div = document.createRange().createContextualFragment(_data);
          let _tableRows = _div.querySelectorAll(`table tbody tr`);
          _tableRows.forEach((i, index) => {
            while (i.cells.length > 7) {
              i.removeChild(i.lastElementChild);
            }
            const actionTypeCell = i.cells[6];
            _editorBarDataContentRows.push(i.outerHTML);
            if (index == 0) return;
            if (i.cells[3].textContent != "") {
              _sentence += 1;
              _words += i.cells[3].textContent.length;
            }
            _actionTypes.push(_.get(actionTypeCell, "textContent", ""));
          });
        }
        const _editorBarDataContent = `<table
					border="0"
					width="100%"
					cellpadding="0"
					cellspacing="0"
					style="text-align: center"
				>
					<tbody>
						${_editorBarDataContentRows.join("")}
					</tbody>
				</table>
				`;

        this.editorBarData.sentenceNum = _sentence;
        this.editorBarData.wordsNum = _words;
        this.$parent.saveWordFrequency({ _sentence, _words });
        this.$emit(
          "updateTranscription",
          {
            transcriptionData: this.transcriptionData.content,
            editorBarData: {
              ...this.editorBarData,
              content: _editorBarDataContent
            }
          },
          () => {
            this.progressData.uploadLoading = false;
            this.loading = false;
          }
        );
        // TODO 不同板块用id做key
        this.actionTypesMap.jsonData["default"] = _actionTypes;
        this.saveActionTypesMap();
      }
    },
    changeEditorBar({ transcriptionData, editorBarData }) {
      this.transcriptionData.content = transcriptionData;
      let _editorBarData = editorBarData;
      try {
        if (typeof _editorBarData === "string") {
          _editorBarData = JSON.parse(_editorBarData);
        }
      } catch (error) {
        console.error(error);
      }
      const _div = document.createElement("div");
      _div.innerHTML = _editorBarData.content;
      const _rows = _div.querySelectorAll("table tbody tr");
      let _content = "";
      if (_rows.length) {
        const _actionTypeColumn = [
          "行为编码",
          ..._.get(this.actionTypesMap, ["jsonData", "default"], [])
        ];
        _content = `<table
					border="0"
					width="100%"
					cellpadding="0"
					cellspacing="0"
					style="text-align: center"
				>
					<tbody>
						${_.zip(_rows, _actionTypeColumn)
              .map(([_row, _actionType], index) => {
                while (_row.cells.length >= 7) {
                  _row.removeChild(_row.lastElementChild);
                }
                let cellname = "td";
                if (index === 0) {
                  cellname = "th";
                }
                const ch = document.createElement(cellname);
                ch.innerHTML = _actionType || "";
                _row.appendChild(ch);
                return _row.outerHTML;
              })
              .join("")}
					</tbody>
				</table>
				`;
      }
      // console.log(_content);
      this.editorBarData = { ..._editorBarData, content: _content };
    },
    // 获取对话记录
    getChatList() {
      return new Promise((resolve, reject) => {
        if (!this.tid) return;
        let _copyTid = this.tid;
        // if (this.chatLoading) return;
        this.chatList = [];
        this.chatLoading = true;
        let params = {
          userid: this.userId,
          groupid: "602def61-005d-11ee-91d8-005056b8q12w",
          // session_name:``
          session_name: `${this.tid}-classroomObservation`
        };
        this.ajax
          .post("https://gpt4.cocorobo.cn/get_agent_park_chat", params)
          .then(res => {
            if (_copyTid != this.tid) return;
            // 	this.chatLoading = false;
            // 	return this.getChatList()
            // };
            let _data = JSON.parse(res.data.FunctionResponse).response;
            if (_data.length > 0) {
              let _chatList = [];
              for (let i = 0; i < _data.length; i++) {
                _chatList.push({
                  loading: false,
                  role: "user",
                  content: _data[i].problem,
                  uid: _data[i].id,
                  AI: "AI",
                  aiContent: _data[i].answer,
                  oldContent: _data[i].answer,
                  isShowSynchronization: false,
                  filename: _data[i].filename,
                  index: i,
                  is_mind_map: false,
                  fileid: _data[i].fileid,
                  createtime: _data[i].createtime
                });
              }
              this.chatList = _chatList;
              this.chatLoading = false;
            } else {
              //没有对话记录
              this.chatLoading = false;
            }
            resolve();
            this.scrollBottom();
          })
          .catch(err => {
            console.log(err);
            this.$message.error("获取对话记录失败");
            this.chatLoading = false;
            this.scrollBottom();
            resolve();
          });
      });
    },
    //保存消息
    async insertChat(_uid) {
      let _data = this.chatList.find(i => i.uid == _uid);

      if (!_data) return;
      let params = {
        userId: this.userId,
        userName: this.userName
          ? this.userName
          : await this.getUser(this.userId),
        groupId: "602def61-005d-11ee-91d8-005056b8q12w",
        answer: _data.aiContent,
        problem: _data.content,
        file_id: _data.fileid ? _data.fileid : "",
        alltext: _data.aiContent,
        type: "chat",
        filename: _data.filename,
        session_name: `${this.tid}-classroomObservation`
      };
      this.ajax
        .post("https://gpt4.cocorobo.cn/insert_chat", params)
        .then(res => {});
    },
    getUser(uid) {
      return new Promise(resolve => {
        let params = { uid: uid };
        this.ajax
          .get(this.$store.state.api + "getUser", params)
          .then(res => {
            let data = res.data[0][0];
            this.userName = data.username;
            resolve(data.username);
          })
          .catch(err => {
            console.error(err);
          });
      });
    },
    // 转录文稿修改
    changeEditor(val) {
      // console.log(val);
      // this.editorBarData.content = val;
      // console.log(this.editorBarData)
      this.$forceUpdate();
    },
    // 初始化
    init() {
      this.transcriptionData.content = "";
      this.chatList = [];
      this.editorBarData = {
        type: "0", //0---文字   1-文件
        content: "",
        url: ""
      };
      this.audioUrl = "";
    },
    async loadActionTypesMap() {
      const res = await this.ajax.post(
        "https://gpt4.cocorobo.cn/get_classroom_observation_new",
        { tid: this.tid, type: "11" }
      );
      const result = _.get(res, ["data", "FunctionResponse", "result"], "[]");
      if (result instanceof Array) {
        return undefined;
      }
      const data = _.get(JSON.parse(result), 0);
      return { ...data, jsonData: JSON.parse(data.jsonData) };
    },
    async insertActionTypes() {
      return await this.ajax.post(
        "https://gpt4.cocorobo.cn/insert_classroom_observation",
        {
          tid: this.tid,
          type: "11",
          json_data: JSON.stringify({ default: [] }),
          index: 0,
          userid: this.userId
        }
      );
    },
    async saveActionTypesMap() {
      try {
        return await this.ajax.post(
          "https://gpt4.cocorobo.cn/update_classroom_observation",
          {
            id: this.actionTypesMap.id,
            json_data: JSON.stringify(this.actionTypesMap.jsonData)
          }
        );
      } catch (e) {
        console.error(e);
        this.$message.error(e);
      }
    },
    async startContinuousJobs(type /* role, actionType */) {
      const key = "default";
      const { appToken, options, attention } = {
        role: {
          appToken: "app-TonzLPv7rPG0EtnFKszOWjwt",
          options: ROLE_OPTIONS_GROUP[key],
          attention: undefined
        },
        actionType: {
          appToken: "app-zOMxBqyEKoJSvW10e5SS0kgj",
          options: OPTIONS_GROUP[key],
          attention: ATTENTION_GROUP[key]
        }
      }[type];
      const config = {
        headers: {
          Authorization: `Bearer ${appToken}`,
          "Content-Type": "application/json"
        }
      };
      const content = this.editorBarData.content;
      const div = document.createElement("div");
      div.innerHTML = content;
      const tableRows = _.slice(div.querySelectorAll(`table tbody tr`), 1);
      if (!tableRows.length || tableRows[0].cells.length < 7) {
        this.$notify.info("没有可编码的内容");
        return;
      }
      const ctrl = new AbortController();
      this.jobContext = {
        ctrl,
        status: "running",
        restart: () => {},
        pause: () => {},
        stop: () => {
          const err = new Error();
          err.name = "StopError";
          this.jobContext.ctrl.abort(err);
        },
        progress: {
          current: 0,
          currentSize: 0,
          total: tableRows.length,
          percentage: 0
        }
      };
      // large chunk size will cause token limit and slower
      const chunkSize = 10;
      this.actionTypesMap.jsonData[key] = Array.from({
        length: tableRows.length
      }).fill("");

      const jobsResult = [];
      const jobs = _.chunk(tableRows, chunkSize).map((rows, index) => {
        return async pauseSignal => {
          this.jobContext.progress.current = index * chunkSize;
          this.jobContext.progress.currentSize = rows.length;
          this.jobContext.progress.percentage =
            ((index * chunkSize) / tableRows.length) * 100;
          const res = await fetch("https://dify.cocorobo.cn/v1/workflows/run", {
            signal: AbortSignal.any([this.jobContext.ctrl.signal, pauseSignal]),
            method: "POST",
            body: JSON.stringify({
              inputs: {
                // PERF better to just include `role` and `content` to minimize token cost
                rows: JSON.stringify(
                  rows.map(r => ({
                    content: r.cells[3].textContent,
                    role: r.cells[5].textContent
                  }))
                ),
                options: options.join(","),
                attention
              },
              response_mode: "blocking",
              user: this.userId
            }),
            ...config
          }).then(res => res.json());
          const error = _.get(res, ["data", "error"], null);
          // test
          // throw new Error('mock error');
          if (error) {
            const err = new Error(error);
            err.name = "DifyError";
            throw err;
          }
          const chunkResult = _.get(res, ["data", "outputs", "result"], []);
          jobsResult.splice(
            index * chunkSize,
            rows.length,
            ...Object.assign(
              new Array(rows.length),
              chunkResult.slice(0, rows.length)
            )
          );
          // PERF dom更新太卡了
          // this.changeEditorBar({
          //   transcriptionData: this.transcriptionData.content,
          //   editorBarData: this.editorBarData,
          // });
        };
      });
      while (!this.jobContext.ctrl.signal.aborted && jobs.length > 0) {
        const job = jobs.shift();
        while (!this.jobContext.ctrl.signal.aborted) {
          const pauseCtrl = new AbortController();
          this.jobContext.pause = () => {
            const err = new Error();
            err.name = "PauseError";
            pauseCtrl.abort(err);
          };
          try {
            await job(pauseCtrl.signal);
            break;
          } catch (err) {
            // console.error(err);
            if (err.name === "StopError") {
              break;
            }
            this.jobContext.status = "paused";
            if (err.name === "PauseError") {
              this.jobContext.error = `用户暂停`;
            } else {
              this.jobContext.error = `部分生成失败。点击按钮可继续尝试生成`;
            }
            try {
              const restartPromise = new Promise((resolve, reject) => {
                this.jobContext.restart = resolve;
                this.jobContext.ctrl.signal.addEventListener("abort", reject);
              });
              await restartPromise;
              this.jobContext.status = "running";
              this.jobContext.error = null;
            } catch (_err) {
              // nothing to do, just continue
            }
          }
        }
      }
      if (type === "actionType") {
        this.actionTypesMap.jsonData[key] = jobsResult;
      } else if (type === "role") {
        const _div = document
          .createRange()
          .createContextualFragment(this.editorBarData.content);
        const _table = _div.querySelector("table");
        const _rows = _table.querySelectorAll(`tbody tr`);
        const _actionTypes = [];
        _rows.forEach((i, index) => {
          while (i.cells.length > 7) {
            i.removeChild(i.lastElementChild);
          }
          if (index == 0) return;
          const actionTypeCell = i.cells[6] && i.removeChild(i.cells[6]);
          i.cells[5].textContent = jobsResult[index - 1];
          _actionTypes.push(_.get(actionTypeCell, "textContent", ""));
        });
        this.actionTypesMap.jsonData[key] = _actionTypes;
        this.editorBarData.content = _table.outerHTML;
      }
      this.changeEditorBar({
        transcriptionData: this.transcriptionData.content,
        editorBarData: this.editorBarData
      });
      this.jobContext = null;
    },
    onEdit(value) {
      const div = document.createElement("div");
      div.innerHTML = value;
      const table = div.querySelector("table");
      if (table) {
        const rows = Array.from(table.querySelectorAll(`tbody tr`)).slice(1);
        this.actionTypesMap.jsonData.default = rows.map(row =>
          _.get(row, ["cells", 6, "textContent"], "")
        );
      }

      this.editorBarData.content = value;
    },
    async convertMp3ToWav(file) {
      const audioContext = new AudioContext();

      // 读取文件内容并解码
      const arrayBuffer = await file.arrayBuffer();
      const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

      // 将AudioBuffer转成WAV格式
      const wavData = this.encodeWAV(audioBuffer);

      // 创建新的WAV格式File对象
      const wavFile = new File([wavData], "课堂观察mp3转wav.wav", {
        type: "audio/wav"
      });

      return wavFile;
    },
    encodeWAV(audioBuffer) {
      const numberOfChannels = audioBuffer.numberOfChannels;
      const length = audioBuffer.length * numberOfChannels * 2 + 44;
      const buffer = new ArrayBuffer(length);
      const view = new DataView(buffer);

      // 写入WAV文件头
      this.writeString(view, 0, "RIFF");
      view.setUint32(4, 36 + audioBuffer.length * numberOfChannels * 2, true);
      this.writeString(view, 8, "WAVE");
      this.writeString(view, 12, "fmt ");
      view.setUint32(16, 16, true);
      view.setUint16(20, 1, true);
      view.setUint16(22, numberOfChannels, true);
      view.setUint32(24, audioBuffer.sampleRate, true);
      view.setUint32(28, audioBuffer.sampleRate * 2 * numberOfChannels, true);
      view.setUint16(32, numberOfChannels * 2, true);
      view.setUint16(34, 16, true);
      this.writeString(view, 36, "data");
      view.setUint32(40, audioBuffer.length * numberOfChannels * 2, true);

      // 写入PCM数据
      let offset = 44;
      for (let i = 0; i < audioBuffer.length; i++) {
        for (let channel = 0; channel < numberOfChannels; channel++) {
          let sample = audioBuffer.getChannelData(channel)[i] * 0x7fff;
          if (sample < 0) sample = Math.max(sample, -0x8000);
          else sample = Math.min(sample, 0x7fff);
          view.setInt16(offset, sample, true);
          offset += 2;
        }
      }

      return new Uint8Array(buffer);
    },
    writeString(view, offset, string) {
      for (let i = 0; i < string.length; i++) {
        view.setUint8(offset + i, string.charCodeAt(i));
      }
    },
    onClickAddNewVoiceprint() {
      this.showTeacherVoiceprintBox = false;
      this.$refs.addNewTeacherVoiceprintDialogRef.open();
    },
    async loadVoiceprints() {
      this.teacherVoiceprintList = await Sy.getVoiceprints({
        userId: this.$route.query["userid"],
        organizeId: this.$route.query["org"]
      });
    },
    onClickStartRecord() {
      if (!this.tid) {
        return this.$parent.addNewCourse().then(_ => {
          this.onClickStartRecord();
        });
      }
      if (this.uploadFileLoading) return this.$message.info("请稍等...");
      // 开始录音
      if (this.audioUrl) {
        this.$confirm("是否创建新的课堂并开始录音？", "提醒", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.recordedForm.status = 0;
            this.audioUrl = "";
            // recorder.initRecorder(); //初始化录音
            // recorder.destroy(); // 销毁录音
            // this.onClickStartRecord();
            return this.$parent.addNewCourse().then(_ => {
              this.onClickStartRecord();
            });
          })
          .catch(e => {
            console.log(e);
            console.log("不顶替");
          });
      } else if (this.controlsStatus != 1 && this.recordedForm.status == 0) {
        this.controlsStatus = 1;
        this.recordedForm.status = 1;
        this.$message.success("已开始录音");
        this.recordedForm.timer = setInterval(() => {
          this.recordedForm.timeDuration += 1;
          this.recordedForm.time = this.updateRecordedTime({
            duration: this.recordedForm.timeDuration
          });
          // console.log(this.recordedForm);
        }, 1000);
        this.recordedForm.textList = [];
        this.recordedForm.timeDuration = 0;
        this.recordedForm.startTime = 1;
        this.recordedForm.endTime = 0;
        this.showIndexPage = false;
        this.pageStatus = 2;

        switch (this.recorderProvider) {
          case "microsoft":
            this.onStartRecordWithMicrosoft();
            break;
          case "shengyang":
            this.onStartRecordWithShengyang();
            break;
          default:
            break;
        }
      } else if ([1, 2].includes(this.recordedForm.status)) {
        this.controlsStatus = 1;
        this.$message.info("还在录音中");
      }
      // this.controlsStatus = 1;
    },
    onClickPauseOrContinueRecord() {
      if (this.recordedForm.loading) return this.$message.info("请稍等");
      if (this.recordedForm.status == 1) {
        //暂停
        this.recordedForm.loading = true;
        clearInterval(this.recordedForm.timer);

        switch (this.recorderProvider) {
          case "microsoft":
            this.onPauseRecordWithMicrosoft().then(() => {
              this.recordedForm.loading = false;
            });
            break;
          case "shengyang":
            this.onPauseRecordWithShengyang().then(() => {
              this.recordedForm.status = 2;
              this.$message.success("已停止录音");
              this.recordedForm.loading = false;
            });
            break;
          default:
            break;
        }
      } else if (this.recordedForm.status == 2) {
        //开始
        this.recordedForm.loading = true;
        this.controlsStatus = 1;
        this.recordedForm.status = 1;
        this.$message.success("已开始录音");
        this.recordedForm.loading = false;
        this.recordedForm.timer = setInterval(() => {
          this.recordedForm.timeDuration += 1;
          this.recordedForm.time = this.updateRecordedTime({
            duration: this.recordedForm.timeDuration
          });
        }, 1000);

        switch (this.recorderProvider) {
          case "microsoft":
            this.onContinueRecordWithMicrosoft();
            break;
          case "shengyang":
            this.onContinueRecordWithShengyang();
            break;
          default:
            break;
        }
      }
    },
    async onClickFinishRecord() {
      clearInterval(this.recordedForm.timer);
      switch (this.recorderProvider) {
        case "microsoft":
          this.onFinishRecordWithMicrosoft();
          break;
        case "shengyang":
          this.onFinishRecordWithShengyang();
          break;
        default:
          break;
      }
    },
    onRecordAddLine(newItem) {
      const _div = document.createElement("div");
      _div.innerHTML = this.editorBarData.content;
      const _rows = Array.from(_div.querySelectorAll("table tbody tr")).slice(
        1
      );
      const newRow = document.createElement("tr");
      newRow.innerHTML = `
            <td>${this.recordedForm.textList.length}</td>
            <td>${newItem.startTime}</td>
            <td>${newItem.endTime}</td>
            <td>${newItem.value}</td>
            <td>${newItem.time}</td>
            <td>${newItem.role}</td>
            <td></td>`;
      _rows.push(newRow);
      const _actionTypeColumn = _.get(
        this.actionTypesMap,
        ["jsonData", "default"],
        []
      );
      this.editorBarData.content = `<table
            border="0"
            width="100%"
            cellpadding="0"
            cellspacing="0"
            style="text-align: center"
          >
            <tbody>
              <tr>
									<th>序号</th>
									<th>开始时间</th>
									<th>结束时间</th>
									<th>发言内容</th>
									<th>时长</th>
									<th>说话人身份</th>
									<th>行为编码</th>
							</tr>
              ${_.zip(_rows, _actionTypeColumn)
                .map(([_row, _actionType], index) => {
                  while (_row.cells.length >= 7) {
                    _row.removeChild(_row.lastElementChild);
                  }
                  const ch = document.createElement("td");
                  ch.innerHTML = _actionType || "";
                  _row.appendChild(ch);
                  return _row.outerHTML;
                })
                .join("")}
            </tbody>
          </table>
          `;
    },
    // ============ start 微软录音转译
    onStartRecordWithMicrosoft() {
      let iiframe = this.$refs["iiframe"];
      iiframe.contentWindow.window.document.getElementById(
        "languageOptions"
      ).selectedIndex = this.languageRadio;
      iiframe.contentWindow.testdoContinuousPronunciationAssessment();
      // 录音开始
      let flag = true;
      iiframe.contentWindow.onRecognizedResult = e => {
        // let e = {
        // 	privText:"测试测试"
        // }
        this.recordedForm.endTime = this.recordedForm.timeDuration;
        if (flag) {
          this.controlsStatus = 1;
          this.showIndexPage = false;
          this.pageStatus = 2;
          this.editorBarData.type = "0";
          flag = false;
          this.uploadFileLoading = false;
          this.transcriptionData.content = "";
          this.editorBarData.content = "";
          this.recordedForm.textList = [];
        }
        this.showGetTextLoading = true;
        let privText = e.privText;
        if (privText == undefined || privText == "undefined") return;
        console.log("👇转译对象👇");
        console.log(e);
        console.log("👇转译结果👇");
        console.log(privText);
        const newItem = {
          value: privText,
          role: "",
          startTime: this.updateRecordedTime({
            duration: this.recordedForm.startTime
          }),
          endTime: this.updateRecordedTime({
            duration: this.recordedForm.endTime
          }),
          time: this.updateRecordedTime({
            duration: this.recordedForm.endTime - this.recordedForm.startTime
          })
        };
        this.recordedForm.textList.push(newItem);
        this.recordedForm.startTime = this.recordedForm.timeDuration + 1;
        this.transcriptionData.content += privText;
        this.onRecordAddLine(newItem);
      };
    },
    async onPauseRecordWithMicrosoft() {
      let _resolve;
      const p = new Promise(resolve => (_resolve = resolve));
      let iiframe = this.$refs["iiframe"];
      iiframe.contentWindow.window.document
        .getElementById("scenarioStopButton")
        .click();
      // 录音借宿
      iiframe.contentWindow.onSessionStopped = (s, e) => {
        this.recordedForm.status = 2;
        this.$message.success("已停止录音");
        console.log("停止录音👇");
        console.log("停止录音", e);
        this.recordedForm.audioBlob.push(e.preaudio);
        iiframe.contentWindow.onSessionStopped = null;
        iiframe.contentWindow.onRecognizedResult = null;
        _resolve();
      };
      return p;
    },
    onContinueRecordWithMicrosoft() {
      let iiframe = this.$refs["iiframe"];
      iiframe.contentWindow.window.document.getElementById(
        "languageOptions"
      ).selectedIndex = this.languageRadio;
      iiframe.contentWindow.testdoContinuousPronunciationAssessment();
      // 录音开始
      iiframe.contentWindow.onRecognizedResult = e => {
        this.recordedForm.endTime = this.recordedForm.timeDuration;
        this.showGetTextLoading = true;
        let privText = e.privText;
        if (privText == undefined || privText == "undefined") return;
        console.log("👇转译对象👇");
        console.log(e);
        console.log("👇转译结果👇");
        console.log(privText);
        const newItem = {
          value: privText,
          role: "",
          startTime: this.updateRecordedTime({
            duration: this.recordedForm.startTime
          }),
          endTime: this.updateRecordedTime({
            duration: this.recordedForm.endTime
          }),
          time: this.updateRecordedTime({
            duration: this.recordedForm.endTime - this.recordedForm.startTime
          })
        };
        this.recordedForm.textList.push(newItem);
        this.recordedForm.startTime = this.recordedForm.timeDuration + 1;
        this.transcriptionData.content += privText;
        this.onRecordAddLine(newItem);
      };
    },
    onFinishRecordWithMicrosoft() {
      if (this.recordedForm.status == 1) {
        //正在录音时
        let iiframe = this.$refs["iiframe"];
        iiframe.contentWindow.window.document
          .getElementById("scenarioStopButton")
          .click();
        // 录音借宿
        iiframe.contentWindow.onSessionStopped = (s, e) => {
          this.recordedForm.status = 3;
          this.controlsStatus = 2;
          this.showGetTextLoading = false;
          this.$message.success("已结束录音");
          console.log("结束录音👇");
          console.log("结束录音", e);
          this.recordedForm.audioBlob.push(e.preaudio);
          let blob = new Blob(this.recordedForm.audioBlob, {
            type: "audio/wav"
          });
          let file = new File([blob], "recordedFile.wav", {
            type: "audio/wav"
          });
          this.uploadFile(file, { changeText: false, flag: true });
          iiframe.contentWindow.onSessionStopped = null;
          iiframe.contentWindow.onRecognizedResult = null;
        };
      } else if (this.recordedForm.status == 2) {
        //暂停录音时
        this.recordedForm.status = 3;
        this.controlsStatus = 2;
        this.showGetTextLoading = false;
        let blob = new Blob(this.recordedForm.audioBlob, {
          type: "audio/wav"
        });
        let file = new File([blob], "recordedFile.wav", { type: "audio/wav" });
        this.uploadFile(file, { changeText: false, flag: true });
      }
    },
    // ============ end 微软录音转译
    // ============ start 声扬录音转译
    onStartRecordWithShengyang() {
      const onProcess = buffers => {
        const data_8 = new Uint8Array(buffers[buffers.length - 1].buffer);
        if (
          data_8.byteLength > 0 &&
          this.shengyangContext.ws.readyState === 1
        ) {
          this.shengyangContext.ws.send(data_8);
        }
      };
      this.shengyangContext.recorder = Recorder({
        type: "mp3",
        sampleRate: 16000,
        bitRate: 16,
        disableEnvInFix: false,
        onProcess
      });
      this.shengyangContext.recorder.open(
        async () => {
          this.shengyangContext.ws = await Sy.createWs({
            enroll_infos: _.map(
              _.filter(this.teacherVoiceprintList, item =>
                this.chosenVoiceprint.includes(item.id)
              ),
              item => ({ feature_data: item.featureData, name: item.name })
            )
          });
          let flag = true;
          this.shengyangContext.ws.onmessage = _.throttle(e => {
            console.log("maxwaited");
            this.recordedForm.endTime = this.recordedForm.timeDuration;
            if (flag) {
              this.controlsStatus = 1;
              this.showIndexPage = false;
              this.pageStatus = 2;
              this.editorBarData.type = "0";
              flag = false;
              this.uploadFileLoading = false;
              this.transcriptionData.content = "";
              this.editorBarData.content = "";
              this.recordedForm.textList = [];
            }
            this.showGetTextLoading = true;

            const all = _.get(JSON.parse(e.data), ["userdata", "results"], []);

            const _actionTypeColumn = _.get(
              this.actionTypesMap,
              ["jsonData", "default"],
              []
            );
            const secondsToHms = seconds => {
              const h = Math.floor(seconds / 3600)
                .toString()
                .padStart(2, "0");
              const m = Math.floor((seconds % 3600) / 60)
                .toString()
                .padStart(2, "0");
              const s = Math.floor(seconds % 60)
                .toString()
                .padStart(2, "0");
              return `${h}:${m}:${s}`;
            };
            this.editorBarData.content = `<table
              border="0"
              width="100%"
              cellpadding="0"
              cellspacing="0"
              style="text-align: center"
            >
              <tbody>
                <tr>
                    <th>序号</th>
                    <th>开始时间</th>
                    <th>结束时间</th>
                    <th>发言内容</th>
                    <th>时长</th>
                    <th>说话人身份</th>
                    <th>行为编码</th>
                </tr>
                ${_.zip(all, _actionTypeColumn)
                  .map(([row, _actionType], index) => {
                    return `
                    <tr>
                      <td>${index + 1}</td>
                      <td>${secondsToHms(row.start_time_s)}</td>
                      <td>${secondsToHms(row.end_time_s)}</td>
                      <td>${row.transcription}</td>
                      <td>${secondsToHms(
                        row.end_time_s - row.start_time_s
                      )}</td>
                      <td>${row.voiceprint_profile_id}</td>
                      <td>${_actionType || ""}</td>
                      </tr>
                    `;
                  })
                  .join("")}
              </tbody>
            </table>
            `;
            // this.transcriptionData.content += privText;
          }, 5000);
          this.shengyangContext.recorder.start();
        },
        (msg, isUserNotAllow) => {
          console.log("Recorder Info: isUserNotAllow", isUserNotAllow, msg);
        }
      );
    },
    async onPauseRecordWithShengyang() {
      this.shengyangContext.recorder.pause();
    },
    onContinueRecordWithShengyang() {
      this.shengyangContext.recorder.resume();
    },
    onFinishRecordWithShengyang() {
      this.shengyangContext.recorder.stop(
        async (blob, duration, mime) => {
          this.recordedForm.status = 3;
          this.controlsStatus = 2;
          this.showGetTextLoading = false;
          this.$message.success("已结束录音");
          const file = new File([blob], `recorded_${Date.now()}.mp3`, {
            type: mime
          });
          this.uploadFile(file, { changeText: false, flag: true });
        },
        errMsg => {
          this.$message.error(errMsg);
        },
        true
      );
      this.shengyangContext.ws.close();
      this.shengyangContext.recorder = null;
      this.shengyangContext.ws = null;
      // TODO
    }
    // ============ end 声扬录音转译
  },
  mounted() {
    this.loadVoiceprints();
  }
};
</script>

<style scoped>
.chatArea {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  /* justify-content: center; */
  box-sizing: border-box;
  padding: 20px;
  position: relative;
}

.audio_class {
  /* width: 100% !important; */
  /* height: 100% !important; */
  background: #ccc !important;
  margin: 0 !important;
}

.audio_class >>> .slider .process {
  background: #000;
}

.tapeSty {
  cursor: pointer;
  width: 40px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding: 10px 15px; */
  border-radius: 20px;
}

.TapeCss {
  background-color: #1467ee;
}

.titBar {
  width: 100%;
  height: 30px;
  margin-bottom: 5px;
  display: flex;
  /* align-items: center; */
  border-bottom: 1px #ccc solid;
  /* z-index: 99; */
}

.titBar > .titBarLeft {
  width: 40%;
  min-width: 400px;
  flex-shrink: 0;
  display: flex;
  cursor: pointer;
  justify-content: flex-start;
}

.titBar > .titBarRig {
  display: flex;
  flex: 1;
  justify-content: flex-end;
  align-items: center;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
}

.titBar > .titBarRig > img {
  margin-right: 5px;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.titBarBorder {
  font-weight: 600;
  box-sizing: border-box;
  border-bottom: 2px #1467ee solid;
}

.titBar > .titBarLeft > div {
  height: 100%;
  font-family: PingFang SC;
  font-size: 16px;
  min-width: 75px;
  margin-right: 30px;
  text-align: left;
  display: flex;
  align-items: center;
}

.titBar > .titBarLeft > div > img {
  margin-right: 5px;
}

.m-operation {
  width: 100%;
  height: 30px;
  display: flex;
  font-size: 14px;
  box-sizing: border-box;
  padding-right: 30px;
  margin-bottom: 10px;
  align-items: baseline;
}

.m-operation :first-child {
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  text-align: left;
  margin-right: 10px;
}

.m-operation :nth-child(2) {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: 400;
  text-align: left;
}

.ca-top {
  width: 100%;
  flex: 1;
}

.ca-bottom {
  width: 100%;
  height: 120px;
}

.ca-b-operation {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: relative;
}

.ca-b-o-header {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
}

.ca-b-o-h-left {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
}

.ca-b-o-h-l-select {
  width: auto;
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
  font-size: 14px;
  box-sizing: border-box;
  padding: 5px 10px;
  margin-right: 20px;
  border-radius: 15px;
  cursor: pointer;
  background-color: white;
}

/* .ca-b-o-h-l-select:hover .languageBlock{
	display: block;
}
.languageBlock {
	display: none;
} */

.languageList {
  position: absolute;
  background-color: #fff;
  top: calc(-100% - 100px);
  left: 0%;
  width: 120px;
  /* padding: 0 10px; */
  /* box-sizing: border-box; */
  padding: 10px 0;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  height: 100px;
}

.languageList >>> .el-radio {
  width: 70%;
  /* margin-bottom: 10px; */
  padding: 5px 10px;
  margin: 0;
  border-radius: 5px;
}

.radioBg {
  background: rgba(243, 247, 253, 1);
}

.ca-b-o-h-l-s-icon {
  margin-right: 2px;
  font-size: 16px;
}

.ca-b-o-h-s-l-icon2 {
  margin-left: 5px;
  font-size: 18px;
}

.ca-b-o-h-l-btn {
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  box-sizing: border-box;
  padding: 5px 10px;
  margin-right: 20px;
  border-radius: 15px;
  background-color: white;
  cursor: pointer;
  position: relative;
}

.ca_teacherVoiceprintBox {
  width: auto;
  height: auto;
  background-color: #fff;
  padding: 10px;
  position: absolute;
  bottom: calc(100% + 5px);
  border-radius: 4px;
  left: 0;
  box-shadow: 0px 2px 4px -1px #0000001f;

  box-shadow: 0px 4px 5px 0px #00000014;

  box-shadow: 0px 1px 10px 0px #0000000d;
}

.ca_teacherVoiceprintBox > div {
  width: 100px;
  padding: 8px;
  margin-top: 10px;
  border-radius: 4px;
  background-color: #fff;
  transition: 0.3s;
  cursor: pointer;
}

.ca_teacherVoiceprintBox > div:hover {
  background-color: #f3f7fd;
}

.ca_tvb_itemHead {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3681fc;
  margin-top: 0 !important;
  border: solid 1px #3681fc;
}

.ca_tvb_itemHead > svg {
  margin-right: 5px;
}

.ca_tvb_itemActive {
  color: #3681fc;
  background-color: #f3f7fd !important;
}

.ca-b-o-h-right {
  width: auto;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ca-b-o-h-r-radio {
  display: flex;
  align-items: center;
  font-size: 14px;
  background-color: #e7e7e7;
  border-radius: 20px;
  overflow: hidden;
}

.ca-b-o-h-r-radio > span {
  margin-right: 5px;
  cursor: pointer;
}

.ca-b-o-main {
  width: 100%;
  /* flex: 1; */
  height: 64px;

  margin-top: 5px;
  border-radius: 16px;
  transition: 0.3s;
  position: relative;
}

.ca-b-o-main:hover {
  box-shadow: 0 5px 10px 10px #e1e8eb;
}

.ca-b-o-m-tape {
  width: 100%;
  height: 100%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #3681fc;
  border-radius: 16px;
  background-color: white;
  box-shadow: 0 5px 10px 10px #e6eaeb;
  transition: 0.3s;
}

.ca-b-o-m-tapeTwo {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #3681fc;
  box-sizing: border-box;
  padding: 0 20px;
  border-radius: 16px;
  background-color: white;
  box-shadow: 0 5px 10px 10px #e6eaeb;
  transition: 0.3s;
}

.ca-b-o-m-tapeTwo >>> .vueAudioBetter {
  width: 90%;
}

.ca-b-o-m-tape > span {
  margin-right: 10px;
  font-size: 22px;
}

.ca-b-o-m-tape:hover {
  color: #1467ee;
}

.ca-b-o-m-inputAre {
  width: 100%;
  min-height: 100%;
  height: auto;
  display: flex;
  align-items: flex-end;
  border-radius: 16px;
  background-color: white;
  box-shadow: 0 5px 10px 10px #e6eaeb;
  transition: 0.3s;
  position: absolute;
  bottom: 0;
}

.ca-b-o-m-TapeArea {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  border-radius: 16px;
  background-color: #f0f2f5;
  box-shadow: 0 5px 10px 10px #e6eaeb;
  transition: 0.3s;
  align-items: center;
  padding-right: 20px;
  box-sizing: border-box;
}

.ca-b-o-m-i-left {
  display: flex;
  align-items: center;
}

.ca-b-o-m-i-left > div > div {
  color: #ee3e3e;
  font-weight: bold;
}

.ca-b-o-m-i-left > div > span {
  font-size: 14px;
  margin-top: 5px;
}

.ca-b-o-m-i-left > img {
  margin-left: 10px;
  border-radius: 50%;
  margin-right: 20px;
}

.ca-b-o-m-left {
  flex: 1;
  height: auto;
  min-height: 64px;
  display: flex;
  /* justify-content: center; */
  align-items: center;
  box-sizing: border-box;
  padding-left: 20px;
}

.ca-b-o-m-left > textarea {
  resize: none;
  min-height: 50px;
  margin: 7px 0;
  max-height: 500px;
  width: 100%;
  font-size: 18px;
  border: none;
  outline: none;
  resize: none;
  overflow: auto;
}

.ca-b-o-m-right {
  width: 100px;
  min-width: 80px;
  height: 64px;
  max-height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
}

#myTextarea::-webkit-input-placeholder {
  /* Chrome, Opera, Safari */
  font-size: 14px;
  /* 修改placeholder字体大小 */
  color: grey;
  /* 修改placeholder文字颜色 */
}

#myTextarea:-moz-placeholder {
  /* Firefox 18- */
  font-size: 14px;
  /* 修改placeholder字体大小 */
  color: grey;
  /* 修改placeholder文字颜色 */
  opacity: 1;
  /* 修复Firefox的透明度问题 */
}

#myTextarea::-moz-placeholder {
  /* Firefox 19+ */
  font-size: 14px;
  /* 修改placeholder字体大小 */
  color: grey;
  /* 修改placeholder文字颜色 */
  opacity: 1;
  /* 修复Firefox的透明度问题 */
}

#myTextarea:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  font-size: 14px;
  /* 修改placeholder字体大小 */
  color: grey;
  /* 修改placeholder文字颜色 */
}

/* .ca-b-o-m-right > span {
	width: 24px;
	height: 24px;
	background: url("../../../../assets/icon/classroomObservation/tapeIng.png")
		no-repeat;
	background-size: 100% 100%;
	cursor: pointer;
	margin-right: 10px;
} */

.ca-b-o-m-right > div {
  width: 52px;
  height: 30px;

  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 14px;
  border-radius: 5px;
  background-color: #1467ee;
  margin-right: 10px;
  cursor: pointer;
}

.ca-b-o-m-r-dsiableBtn {
  /* 禁止手势 */
  cursor: not-allowed !important;
  background-color: #aeccfe !important;
}

.lyStart {
  width: 38px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 5px;
  cursor: pointer;
}

.ca_b_o_m_roleList {
  position: absolute;
  left: 0;
  width: 100%;
  height: auto;
  max-height: calc(100vh - 230px);
  margin-bottom: 70px;
  overflow: auto;
  background-color: white;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 15px;
}

.ca_b_o_m_rl_item {
  width: 100%;
  height: auto;
  margin-bottom: 15px;
  background-color: #f3f7fd;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.3s;
  box-sizing: border-box;
  padding: 10px;
}

.ca_b_o_m_rl_itemActive {
  background-color: #c3ddfa;
}

.ca_b_o_m_rl_i_left {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 15px;
}

.ca_b-o_m_rl_i_top {
  display: flex;
}

.ca_b-o_m_rl_i_top > div {
  margin-left: 10px;
}

.ca_b-o_m_rl_i_top > div > span {
  font-size: 14px;
  margin-top: 5px;
  color: #6b798e;
}

.ca_b-o_m_rl_i_bottom {
  margin-top: 10px;
  width: 90%;
  overflow: hidden;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ca-top >>> .editorBar {
  height: 100%;
  position: relative;
  max-height: calc(100vh - 300px);
}

.ca-top >>> .editorBar .text {
  height: calc(100% - 42px);
  max-height: calc(100% - 42px);
  overflow: auto;
}

.chatAreaLoading {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}

.cal_box {
  width: 300px;
  height: 150px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 0 4px 4px #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 20px;
}

.cal_box > div:nth-child(1) {
  margin-bottom: 10px;
  font-size: 18px;
  display: flex;
  align-items: center;
}

.cal_box > div:nth-child(1) > img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.cal_box >>> .el-progress-bar__innerText {
  color: #fff !important;
}

.wavGetTextProgress{
	width: 250px;
	height: 32px;
	box-sizing: border-box;
	padding: 3px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/classroomObservation/components/chatArea.vue